/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './base-types.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AddressFieldsFragment = { id: string, buildingNumber: string | null, buildingName: string | null, street: string, city: string, postcode: string, what3words: string | null, latitude: number | null, longitude: number | null };

export type AllPriceBreakdownFragment = { ticketsPrice: number, ticketsDiscountedPrice: number, discountsValue: number, subtotalPrice: number, miscCostsValue: number, totalPrice: number, tickets: Array<{ number: number, totalPrice: number, seatGroup: { id: string, name: string } | null, concessionType: { id: string, name: string } | null } | null> | null, miscCosts: Array<{ name: string, description: string | null, percentage: number | null, value: number | null } | null> | null };

export type BasicBookingDetailsFragment = { id: string, reference: string, status: Types.BookingsBookingStatusChoices, user: { id: string | null, firstName: string, lastName: string }, performance: { id: string, start: any, end: any, doorsOpen: any, production: { id: string, name: string, slug: string } }, tickets: Array<{ id: string }> };

export type BookingPaymentDetailsFragment = { transactions: { edges: Array<{ node: { id: string, createdAt: any, type: Types.PaymentsTransactionTypeChoices, providerName: Types.PaymentsTransactionProviderNameChoices, providerTransactionId: string | null, providerFee: number | null, value: number, cardBrand: string | null, last4: string | null } | null } | null> } | null };

export type BookingTicketDetailsFragment = { tickets: Array<{ id: string, checkedInAt: any, seatGroup: { id: string, name: string }, concessionType: { id: string, name: string }, checkedInBy: { firstName: string, lastName: string } | null }> };

export type BookingWithProductionDetailsFragment = { id: string, reference: string, status: Types.BookingsBookingStatusChoices, accessibilityInfo: string | null, priceBreakdown: { ticketsPrice: number, ticketsDiscountedPrice: number, discountsValue: number, subtotalPrice: number, miscCostsValue: number, totalPrice: number, tickets: Array<{ number: number, totalPrice: number, seatGroup: { id: string, name: string } | null, concessionType: { id: string, name: string } | null } | null> | null, miscCosts: Array<{ name: string, description: string | null, percentage: number | null, value: number | null } | null> | null } | null, tickets: Array<{ id: string, seatGroup: { id: string, name: string }, concessionType: { id: string, name: string } }>, performance: { id: string, start: any, end: any, doorsOpen: any, durationMins: number | null, intervalDurationMins: number | null, isRelaxed: boolean | null, relaxedName: string | null, production: { id: string, name: string, slug: string, subtitle: string | null, society: { id: string, name: string, slug: string, logo: { id: string, url: string | null } } | null, featuredImage: { id: string, url: string | null } | null }, venue: { id: string, slug: string } | null }, transactions: { edges: Array<{ node: { id: string, createdAt: any, type: Types.PaymentsTransactionTypeChoices, providerName: Types.PaymentsTransactionProviderNameChoices, providerTransactionId: string | null, providerFee: number | null, value: number, cardBrand: string | null, last4: string | null } | null } | null> } | null };

export type DetailedBookingDetailsFragment = { id: string, reference: string, expired: boolean, expiresAt: any, status: Types.BookingsBookingStatusChoices, accessibilityInfo: string | null, previousAccessibilityInfo: string | null, accessibilityInfoUpdatedAt: any, canModifyAccessibility: boolean, user: { id: string | null, firstName: string, lastName: string }, salesBreakdown: { totalPayments: number } | null, priceBreakdown: { ticketsPrice: number, ticketsDiscountedPrice: number, discountsValue: number, subtotalPrice: number, miscCostsValue: number, totalPrice: number, tickets: Array<{ number: number, totalPrice: number, seatGroup: { id: string, name: string } | null, concessionType: { id: string, name: string } | null } | null> | null, miscCosts: Array<{ name: string, description: string | null, percentage: number | null, value: number | null } | null> | null } | null, performance: { id: string, start: any, end: any, doorsOpen: any, isRelaxed: boolean | null, relaxedName: string | null, durationMins: number | null, intervalDurationMins: number | null, production: { id: string, name: string, slug: string }, relaxedCategories: Array<{ id: string, shortDescription: string, longDescription: string | null } | null> | null, venue: { id: string, slug: string } | null }, tickets: Array<{ id: string, checkedInAt: any, seatGroup: { id: string, name: string }, concessionType: { id: string, name: string }, checkedInBy: { firstName: string, lastName: string } | null }>, transactions: { edges: Array<{ node: { id: string, createdAt: any, type: Types.PaymentsTransactionTypeChoices, providerName: Types.PaymentsTransactionProviderNameChoices, providerTransactionId: string | null, providerFee: number | null, value: number, cardBrand: string | null, last4: string | null } | null } | null> } | null };

export type PerformanceTicketOptionsFragmentFragment = { id: string, capacityRemaining: number | null, price: number, seatGroup: { id: string, name: string, description: string | null, capacity: number | null }, concessionTypes: Array<{ price: number | null, concessionType: { id: string, name: string, description: string | null } | null } | null> | null };

export type ProductionBasicInfoFragment = { id: string, name: string, subtitle: string | null, description: string | null, contactEmail: string | null, status: Types.ProductionsProductionStatusChoices, ageRating: number | null, slug: string, start: any, end: any, minSeatPrice: number | null, productionAlert: string | null, isBookable: boolean, society: { id: string, name: string, slug: string, logo: { id: string, url: string | null } } | null, featuredImage: { id: string, url: string | null } | null, contentWarnings: Array<{ information: string | null, warning: { id: string, shortDescription: string, longDescription: string | null } }> | null };

export type ProductionPerformancesFragment = { performances: { edges: Array<{ node: { id: string, disabled: boolean, description: string | null, doorsOpen: any, start: any, end: any, durationMins: number | null, soldOut: boolean, isInperson: boolean, isOnline: boolean, isRelaxed: boolean | null, relaxedName: string | null, isBookable: boolean, venue: { id: string, name: string, slug: string } | null, relaxedCategories: Array<{ id: string, shortDescription: string, longDescription: string | null } | null> | null } | null } | null> } };

export type ProductionsDetailsFragmentFragment = { edges: Array<{ node: { id: string, slug: string, name: string, start: any, end: any, isBookable: boolean, society: { name: string } | null, featuredImage: { id: string, url: string | null } | null, coverImage: { id: string, url: string | null } | null, venues: Array<{ id: string, name: string }> | null, performances: { edges: Array<{ node: { id: string, doorsOpen: any, start: any, soldOut: boolean, end: any, venue: { id: string, name: string } | null, production: { id: string, name: string, featuredImage: { url: string | null } | null } } | null } | null> } } | null } | null> };

export type AuthUserDetailsFragment = { firstName: string, lastName: string, email: string, permissions: Array<string | null> | null };

export type GenerateReportMutationVariables = Exact<{
  name: string;
  start?: any;
  end?: any;
  options?: Array<Types.ReportOption | null | undefined> | Types.ReportOption | null | undefined;
}>;


export type GenerateReportMutation = { generateReport: { success: boolean, downloadUri: string | null, errors: Array<
      | { message: string | null, code: string | null, field: string | null }
      | { message: string | null, code: string | null }
    > | null } | null };

export type ConcessionTypeMutationMutationVariables = Exact<{
  input: Types.ConcessionTypeMutationInput;
}>;


export type ConcessionTypeMutationMutation = { concessionType: { success: boolean, concessionType: { id: string } | null, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type DeleteDiscountMutationMutationVariables = Exact<{
  id: string;
}>;


export type DeleteDiscountMutationMutation = { deleteDiscount: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type DeletePerformanceSeatGroupMutationMutationVariables = Exact<{
  id: string;
}>;


export type DeletePerformanceSeatGroupMutationMutation = { deletePerformanceSeatGroup: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type DiscountMutationMutationVariables = Exact<{
  input: Types.DiscountMutationInput;
}>;


export type DiscountMutationMutation = { discount: { success: boolean, discount: { id: string } | null, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type DiscountRequirementMutationMutationVariables = Exact<{
  input: Types.DiscountRequirementMutationInput;
}>;


export type DiscountRequirementMutationMutation = { discountRequirement: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type PerformanceMutationMutationVariables = Exact<{
  input: Types.PerformanceMutationInput;
}>;


export type PerformanceMutationMutation = { performance: { success: boolean, performance: { id: string } | null, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type PerformanceSeatGroupMutationVariables = Exact<{
  input: Types.PerformanceSeatGroupMutationInput;
}>;


export type PerformanceSeatGroupMutation = { performanceSeatGroup: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type ProductionMutationMutationVariables = Exact<{
  input: Types.ProductionMutationInput;
}>;


export type ProductionMutationMutation = { production: { success: boolean, production: { id: string, slug: string } | null, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type ProductionPermissionsMutationsMutationVariables = Exact<{
  productionId: string;
  permissions: Array<string | null | undefined> | string;
  userEmail: string;
}>;


export type ProductionPermissionsMutationsMutation = { productionPermissions: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type SetProductionStatusMutationVariables = Exact<{
  id: string;
  status: Types.Status;
  message?: string | null | undefined;
}>;


export type SetProductionStatusMutation = { setProductionStatus: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type ActiveAccountMutationMutationVariables = Exact<{
  token: string;
}>;


export type ActiveAccountMutationMutation = { verifyAccount: { success: boolean, errors: Array<
      | { message: string | null, field: string | null, code: string | null }
      | { message: string | null, code: string | null }
    > | null } | null };

export type LoginMutationMutationVariables = Exact<{
  email: string;
  password: string;
}>;


export type LoginMutationMutation = { login: { success: boolean, token: string | null, refreshToken: string | null, user: { verified: boolean | null } | null, errors: Array<
      | { message: string | null, field: string | null, code: string | null }
      | { message: string | null, code: string | null }
    > | null } | null };

export type RefreshTokenMutationMutationVariables = Exact<{
  refreshToken: string;
}>;


export type RefreshTokenMutationMutation = { refreshToken: { token: string | null, refreshToken: string | null } | null };

export type RegisterUserMutationMutationVariables = Exact<{
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmedPassword: string;
  turnstileToken: string;
}>;


export type RegisterUserMutationMutation = { register: { success: boolean, errors: Array<
      | { message: string | null, field: string | null, code: string | null }
      | { message: string | null, code: string | null }
    > | null } | null };

export type RequestPasswordResetMutationMutationVariables = Exact<{
  email: string;
}>;


export type RequestPasswordResetMutationMutation = { sendPasswordResetEmail: { success: boolean, errors: Array<
      | { message: string | null, field: string | null, code: string | null }
      | { message: string | null, code: string | null }
    > | null } | null };

export type ResendActivationMutationMutationVariables = Exact<{
  email: string;
}>;


export type ResendActivationMutationMutation = { resendActivationEmail: { success: boolean, errors: Array<
      | { message: string | null, field: string | null, code: string | null }
      | { message: string | null, code: string | null }
    > | null } | null };

export type ResetPasswordMutationMutationVariables = Exact<{
  token: string;
  password: string;
  confirmedPassword: string;
}>;


export type ResetPasswordMutationMutation = { passwordReset: { success: boolean, errors: Array<
      | { message: string | null, field: string | null, code: string | null }
      | { message: string | null, code: string | null }
    > | null } | null };

export type BookingMutationVariables = Exact<{
  input: Types.BookingMutationInput;
}>;


export type BookingMutation = { booking: { success: boolean, booking: { id: string, reference: string, expired: boolean, expiresAt: any, status: Types.BookingsBookingStatusChoices, accessibilityInfo: string | null, previousAccessibilityInfo: string | null, accessibilityInfoUpdatedAt: any, canModifyAccessibility: boolean, user: { id: string | null, firstName: string, lastName: string }, salesBreakdown: { totalPayments: number } | null, priceBreakdown: { ticketsPrice: number, ticketsDiscountedPrice: number, discountsValue: number, subtotalPrice: number, miscCostsValue: number, totalPrice: number, tickets: Array<{ number: number, totalPrice: number, seatGroup: { id: string, name: string } | null, concessionType: { id: string, name: string } | null } | null> | null, miscCosts: Array<{ name: string, description: string | null, percentage: number | null, value: number | null } | null> | null } | null, performance: { id: string, start: any, end: any, doorsOpen: any, isRelaxed: boolean | null, relaxedName: string | null, durationMins: number | null, intervalDurationMins: number | null, production: { id: string, name: string, slug: string }, relaxedCategories: Array<{ id: string, shortDescription: string, longDescription: string | null } | null> | null, venue: { id: string, slug: string } | null }, tickets: Array<{ id: string, checkedInAt: any, seatGroup: { id: string, name: string }, concessionType: { id: string, name: string }, checkedInBy: { firstName: string, lastName: string } | null }>, transactions: { edges: Array<{ node: { id: string, createdAt: any, type: Types.PaymentsTransactionTypeChoices, providerName: Types.PaymentsTransactionProviderNameChoices, providerTransactionId: string | null, providerFee: number | null, value: number, cardBrand: string | null, last4: string | null } | null } | null> } | null } | null, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type CancelPaymentMutationVariables = Exact<{
  paymentId: string;
}>;


export type CancelPaymentMutation = { cancelPayment: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type DeleteBookingMutationVariables = Exact<{
  bookingId: string;
}>;


export type DeleteBookingMutation = { deleteBooking: { success: boolean, errors: Array<
      | { message: string | null }
      | Record<PropertyKey, never>
    > | null } | null };

export type PayBookingMutationVariables = Exact<{
  id: string;
  totalPence: number;
  nonce?: string | null | undefined;
  provider?: Types.PaymentProvider | null | undefined;
  idempotencyKey?: string | null | undefined;
  deviceId?: string | null | undefined;
  verifyToken?: string | null | undefined;
}>;


export type PayBookingMutation = { payBooking: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null, payment: { id: string, status: Types.PaymentsTransactionStatusChoices, value: number, currency: string, cardBrand: string | null, last4: string | null } | null, booking: { id: string, reference: string, expired: boolean, expiresAt: any, status: Types.BookingsBookingStatusChoices, accessibilityInfo: string | null, previousAccessibilityInfo: string | null, accessibilityInfoUpdatedAt: any, canModifyAccessibility: boolean, user: { id: string | null, firstName: string, lastName: string }, salesBreakdown: { totalPayments: number } | null, priceBreakdown: { ticketsPrice: number, ticketsDiscountedPrice: number, discountsValue: number, subtotalPrice: number, miscCostsValue: number, totalPrice: number, tickets: Array<{ number: number, totalPrice: number, seatGroup: { id: string, name: string } | null, concessionType: { id: string, name: string } | null } | null> | null, miscCosts: Array<{ name: string, description: string | null, percentage: number | null, value: number | null } | null> | null } | null, performance: { id: string, start: any, end: any, doorsOpen: any, isRelaxed: boolean | null, relaxedName: string | null, durationMins: number | null, intervalDurationMins: number | null, production: { id: string, name: string, slug: string }, relaxedCategories: Array<{ id: string, shortDescription: string, longDescription: string | null } | null> | null, venue: { id: string, slug: string } | null }, tickets: Array<{ id: string, checkedInAt: any, seatGroup: { id: string, name: string }, concessionType: { id: string, name: string }, checkedInBy: { firstName: string, lastName: string } | null }>, transactions: { edges: Array<{ node: { id: string, createdAt: any, type: Types.PaymentsTransactionTypeChoices, providerName: Types.PaymentsTransactionProviderNameChoices, providerTransactionId: string | null, providerFee: number | null, value: number, cardBrand: string | null, last4: string | null } | null } | null> } | null } | null } | null };

export type SetBookingUserMutationVariables = Exact<{
  id: string | number;
  email: string;
}>;


export type SetBookingUserMutation = { booking: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type UpdateBookingAccessibilityInfoMutationVariables = Exact<{
  id: string;
  accessibilityInfo?: string | null | undefined;
}>;


export type UpdateBookingAccessibilityInfoMutation = { updateBookingAccessibilityInfo: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type CheckInBookingMutationVariables = Exact<{
  reference: string;
  performanceId: string;
  tickets: Array<Types.TicketIdInput | null | undefined> | Types.TicketIdInput;
}>;


export type CheckInBookingMutation = { checkInBooking: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null, booking: { id: string, reference: string, expired: boolean, expiresAt: any, status: Types.BookingsBookingStatusChoices, accessibilityInfo: string | null, previousAccessibilityInfo: string | null, accessibilityInfoUpdatedAt: any, canModifyAccessibility: boolean, user: { id: string | null, firstName: string, lastName: string }, salesBreakdown: { totalPayments: number } | null, priceBreakdown: { ticketsPrice: number, ticketsDiscountedPrice: number, discountsValue: number, subtotalPrice: number, miscCostsValue: number, totalPrice: number, tickets: Array<{ number: number, totalPrice: number, seatGroup: { id: string, name: string } | null, concessionType: { id: string, name: string } | null } | null> | null, miscCosts: Array<{ name: string, description: string | null, percentage: number | null, value: number | null } | null> | null } | null, performance: { id: string, start: any, end: any, doorsOpen: any, isRelaxed: boolean | null, relaxedName: string | null, durationMins: number | null, intervalDurationMins: number | null, production: { id: string, name: string, slug: string }, relaxedCategories: Array<{ id: string, shortDescription: string, longDescription: string | null } | null> | null, venue: { id: string, slug: string } | null }, tickets: Array<{ id: string, checkedInAt: any, seatGroup: { id: string, name: string }, concessionType: { id: string, name: string }, checkedInBy: { firstName: string, lastName: string } | null }>, transactions: { edges: Array<{ node: { id: string, createdAt: any, type: Types.PaymentsTransactionTypeChoices, providerName: Types.PaymentsTransactionProviderNameChoices, providerTransactionId: string | null, providerFee: number | null, value: number, cardBrand: string | null, last4: string | null } | null } | null> } | null } | null } | null };

export type UnCheckInBookingMutationVariables = Exact<{
  reference: string;
  performanceId: string;
  tickets: Array<Types.TicketIdInput | null | undefined> | Types.TicketIdInput;
}>;


export type UnCheckInBookingMutation = { uncheckInBooking: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null, booking: { id: string, reference: string, expired: boolean, expiresAt: any, status: Types.BookingsBookingStatusChoices, accessibilityInfo: string | null, previousAccessibilityInfo: string | null, accessibilityInfoUpdatedAt: any, canModifyAccessibility: boolean, user: { id: string | null, firstName: string, lastName: string }, salesBreakdown: { totalPayments: number } | null, priceBreakdown: { ticketsPrice: number, ticketsDiscountedPrice: number, discountsValue: number, subtotalPrice: number, miscCostsValue: number, totalPrice: number, tickets: Array<{ number: number, totalPrice: number, seatGroup: { id: string, name: string } | null, concessionType: { id: string, name: string } | null } | null> | null, miscCosts: Array<{ name: string, description: string | null, percentage: number | null, value: number | null } | null> | null } | null, performance: { id: string, start: any, end: any, doorsOpen: any, isRelaxed: boolean | null, relaxedName: string | null, durationMins: number | null, intervalDurationMins: number | null, production: { id: string, name: string, slug: string }, relaxedCategories: Array<{ id: string, shortDescription: string, longDescription: string | null } | null> | null, venue: { id: string, slug: string } | null }, tickets: Array<{ id: string, checkedInAt: any, seatGroup: { id: string, name: string }, concessionType: { id: string, name: string }, checkedInBy: { firstName: string, lastName: string } | null }>, transactions: { edges: Array<{ node: { id: string, createdAt: any, type: Types.PaymentsTransactionTypeChoices, providerName: Types.PaymentsTransactionProviderNameChoices, providerTransactionId: string | null, providerFee: number | null, value: number, cardBrand: string | null, last4: string | null } | null } | null> } | null } | null } | null };

export type AttemptPasswordResetMutationVariables = Exact<{
  token: string;
  newPassword: string;
  confirmedNewPassword: string;
}>;


export type AttemptPasswordResetMutation = { passwordReset: { success: boolean, errors: Array<
      | { message: string | null, field: string | null }
      | { message: string | null }
    > | null } | null };

export type AllSiteMessagesQueryVariables = Exact<{
  afterCursor?: string | null | undefined;
}>;


export type AllSiteMessagesQuery = { siteMessages: { edges: Array<{ node: { id: string, message: string, active: boolean, indefiniteOverride: boolean, displayStart: any, eventStart: any, eventEnd: any, eventDuration: number | null, type: Types.SiteMessagesMessageTypeChoices, dismissalPolicy: Types.SiteMessagesMessageDismissalPolicyChoices, toDisplay: boolean | null, creator: { id: string | null, firstName: string, lastName: string } | null } | null } | null> } | null };

export type AllSocietiesQueryVariables = Exact<{
  afterCursor?: string | null | undefined;
}>;


export type AllSocietiesQuery = { societies: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { id: string, name: string, slug: string, logo: { id: string, url: string | null } } | null } | null> } | null };

export type UserDraftBookingForPerformanceQueryVariables = Exact<{
  performanceID: string | number;
}>;


export type UserDraftBookingForPerformanceQuery = { me: { bookings: { edges: Array<{ node: { id: string, reference: string, expired: boolean, expiresAt: any, status: Types.BookingsBookingStatusChoices, accessibilityInfo: string | null, previousAccessibilityInfo: string | null, accessibilityInfoUpdatedAt: any, canModifyAccessibility: boolean, user: { id: string | null, firstName: string, lastName: string }, salesBreakdown: { totalPayments: number } | null, priceBreakdown: { ticketsPrice: number, ticketsDiscountedPrice: number, discountsValue: number, subtotalPrice: number, miscCostsValue: number, totalPrice: number, tickets: Array<{ number: number, totalPrice: number, seatGroup: { id: string, name: string } | null, concessionType: { id: string, name: string } | null } | null> | null, miscCosts: Array<{ name: string, description: string | null, percentage: number | null, value: number | null } | null> | null } | null, performance: { id: string, start: any, end: any, doorsOpen: any, isRelaxed: boolean | null, relaxedName: string | null, durationMins: number | null, intervalDurationMins: number | null, production: { id: string, name: string, slug: string }, relaxedCategories: Array<{ id: string, shortDescription: string, longDescription: string | null } | null> | null, venue: { id: string, slug: string } | null }, tickets: Array<{ id: string, checkedInAt: any, seatGroup: { id: string, name: string }, concessionType: { id: string, name: string }, checkedInBy: { firstName: string, lastName: string } | null }>, transactions: { edges: Array<{ node: { id: string, createdAt: any, type: Types.PaymentsTransactionTypeChoices, providerName: Types.PaymentsTransactionProviderNameChoices, providerTransactionId: string | null, providerFee: number | null, value: number, cardBrand: string | null, last4: string | null } | null } | null> } | null } | null } | null> } } | null };

export type FullPerformanceAndTicketOptionsQueryVariables = Exact<{
  id: string | number;
}>;


export type FullPerformanceAndTicketOptionsQuery = { performance: { id: string, capacityRemaining: number | null, disabled: boolean, doorsOpen: any, start: any, end: any, durationMins: number | null, soldOut: boolean, isInperson: boolean, isOnline: boolean, venue: { id: string, name: string, slug: string } | null, production: { id: string, name: string, subtitle: string | null, description: string | null, contactEmail: string | null, status: Types.ProductionsProductionStatusChoices, ageRating: number | null, slug: string, start: any, end: any, minSeatPrice: number | null, productionAlert: string | null, isBookable: boolean, society: { id: string, name: string, slug: string, logo: { id: string, url: string | null } } | null, featuredImage: { id: string, url: string | null } | null, contentWarnings: Array<{ information: string | null, warning: { id: string, shortDescription: string, longDescription: string | null } }> | null, performances: { edges: Array<{ node: { id: string, disabled: boolean, description: string | null, doorsOpen: any, start: any, end: any, durationMins: number | null, soldOut: boolean, isInperson: boolean, isOnline: boolean, isRelaxed: boolean | null, relaxedName: string | null, isBookable: boolean, venue: { id: string, name: string, slug: string } | null, relaxedCategories: Array<{ id: string, shortDescription: string, longDescription: string | null } | null> | null } | null } | null> } }, discounts: { edges: Array<{ node: { id: string, name: string | null, seatGroup: { id: string, name: string } | null, requirements: Array<{ number: number, concessionType: { id: string, name: string } }> | null } | null } | null> }, ticketOptions: Array<{ id: string, capacityRemaining: number | null, price: number, seatGroup: { id: string, name: string, description: string | null, capacity: number | null }, concessionTypes: Array<{ price: number | null, concessionType: { id: string, name: string, description: string | null } | null } | null> | null } | null> | null } | null };

export type HomepageUpcomingProductionsQueryVariables = Exact<{
  now?: any;
}>;


export type HomepageUpcomingProductionsQuery = { productions: { edges: Array<{ node: { id: string, name: string, slug: string, subtitle: string | null, description: string | null, shortDescription: string | null, start: any, end: any, featuredImage: { id: string, url: string | null } | null, coverImage: { id: string, url: string | null } | null, society: { id: string, name: string, slug: string } | null } | null } | null> } | null };

export type MiscCostsQueryVariables = Exact<{ [key: string]: never; }>;


export type MiscCostsQuery = { miscCosts: { edges: Array<{ node: { name: string, description: string | null, percentage: number | null, value: number | null } | null } | null> } | null };

export type PerformanceTicketOptionsQueryVariables = Exact<{
  id: string | number;
}>;


export type PerformanceTicketOptionsQuery = { performance: { id: string, capacityRemaining: number | null, discounts: { edges: Array<{ node: { id: string, name: string | null, seatGroup: { id: string, name: string } | null, requirements: Array<{ number: number, concessionType: { id: string, name: string } }> | null } | null } | null> }, ticketOptions: Array<{ capacityRemaining: number | null, seatGroup: { id: string, name: string, description: string | null }, concessionTypes: Array<{ price: number | null, concessionType: { id: string, name: string, description: string | null } | null } | null> | null } | null> | null } | null };

export type ProductionBySlugQueryVariables = Exact<{
  slug: string;
}>;


export type ProductionBySlugQuery = { production: { id: string, name: string, status: Types.ProductionsProductionStatusChoices, subtitle: string | null, description: string | null, contactEmail: string | null, ageRating: number | null, facebookEvent: string | null, slug: string, start: any, end: any, minSeatPrice: number | null, productionAlert: string | null, isBookable: boolean, society: { id: string, name: string, slug: string, logo: { id: string, url: string | null } } | null, posterImage: { id: string, url: string | null } | null, featuredImage: { id: string, url: string | null } | null, coverImage: { id: string, url: string | null } | null, contentWarnings: Array<{ information: string | null, warning: { id: string, shortDescription: string, longDescription: string | null } }> | null, performances: { edges: Array<{ node: { id: string, doorsOpen: any, isBookable: boolean, start: any, end: any, soldOut: boolean, durationMins: number | null, intervalDurationMins: number | null, isOnline: boolean, isInperson: boolean, isRelaxed: boolean | null, relaxedName: string | null, venue: { id: string, name: string, slug: string, publiclyListed: boolean } | null, relaxedCategories: Array<{ id: string, shortDescription: string, longDescription: string | null } | null> | null, ticketsBreakdown: { totalCapacity: number } } | null } | null> }, crew: Array<{ name: string, role: { department: Types.ProductionsCrewRoleDepartmentChoices } | null }> | null, cast: Array<{ name: string, role: string | null, profilePicture: { url: string | null } | null }> | null, productionTeam: Array<{ name: string, role: string | null }> | null } | null };

export type RelaxedCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type RelaxedCategoriesQuery = { relaxedCategories: { edges: Array<{ node: { id: string, shortDescription: string, longDescription: string | null, helpText: string | null, defaultRelaxed: boolean, defaultSensoryFriendly: boolean } | null } | null> } | null };

export type SocietyDetailQueryVariables = Exact<{
  slug: string;
}>;


export type SocietyDetailQuery = { society: { name: string, id: string, description: string, slug: string, website: string | null, contact: string | null, logo: { id: string, url: string | null }, banner: { id: string, url: string | null }, productions: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { id: string, name: string, slug: string, start: any, end: any, isBookable: boolean, featuredImage: { url: string | null } | null, coverImage: { url: string | null } | null, society: { name: string } | null } | null } | null> } } | null };

export type UpcomingProductionsQueryVariables = Exact<{
  now?: any;
  afterCursor?: string | null | undefined;
}>;


export type UpcomingProductionsQuery = { productions: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { id: string, name: string, slug: string, start: any, end: any, isBookable: boolean, featuredImage: { id: string, url: string | null } | null } | null } | null> } | null };

export type UpcomingSiteMessagesQueryVariables = Exact<{
  afterCursor?: string | null | undefined;
  displayLocation?: Types.SiteMessagesMessageDisplayLocationChoices | null | undefined;
}>;


export type UpcomingSiteMessagesQuery = { siteMessages: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { id: string, title: string | null, message: string, active: boolean, indefiniteOverride: boolean, displayStart: any, eventStart: any, eventEnd: any, eventDuration: number | null, type: Types.SiteMessagesMessageTypeChoices, dismissalPolicy: Types.SiteMessagesMessageDismissalPolicyChoices, toDisplay: boolean | null, creator: { id: string | null, firstName: string, lastName: string } | null } | null } | null> } | null };

export type UserCompletedBookingQueryVariables = Exact<{
  bookingRef: string;
}>;


export type UserCompletedBookingQuery = { me: { bookings: { edges: Array<{ node: { canModifyAccessibility: boolean, id: string, reference: string, status: Types.BookingsBookingStatusChoices, accessibilityInfo: string | null, priceBreakdown: { ticketsPrice: number, ticketsDiscountedPrice: number, discountsValue: number, subtotalPrice: number, miscCostsValue: number, totalPrice: number, tickets: Array<{ number: number, totalPrice: number, seatGroup: { id: string, name: string } | null, concessionType: { id: string, name: string } | null } | null> | null, miscCosts: Array<{ name: string, description: string | null, percentage: number | null, value: number | null } | null> | null } | null, tickets: Array<{ id: string, seatGroup: { id: string, name: string }, concessionType: { id: string, name: string } }>, performance: { id: string, start: any, end: any, doorsOpen: any, durationMins: number | null, intervalDurationMins: number | null, isRelaxed: boolean | null, relaxedName: string | null, production: { id: string, name: string, slug: string, subtitle: string | null, society: { id: string, name: string, slug: string, logo: { id: string, url: string | null } } | null, featuredImage: { id: string, url: string | null } | null }, venue: { id: string, slug: string } | null }, transactions: { edges: Array<{ node: { id: string, createdAt: any, type: Types.PaymentsTransactionTypeChoices, providerName: Types.PaymentsTransactionProviderNameChoices, providerTransactionId: string | null, providerFee: number | null, value: number, cardBrand: string | null, last4: string | null } | null } | null> } | null } | null } | null> } } | null };

export type VenuesQueryVariables = Exact<{ [key: string]: never; }>;


export type VenuesQuery = { venues: { edges: Array<{ node: { id: string, name: string, internalCapacity: number, slug: string, image: { url: string | null } } | null } | null> } | null };

export type WarningsQueryVariables = Exact<{ [key: string]: never; }>;


export type WarningsQuery = { warnings: { edges: Array<{ node: { id: string, shortDescription: string, longDescription: string | null } | null } | null> } | null };

export type AdminBookingLookupQueryVariables = Exact<{
  reference: string;
}>;


export type AdminBookingLookupQuery = { bookings: { edges: Array<{ node: { id: string, reference: string, expired: boolean, expiresAt: any, status: Types.BookingsBookingStatusChoices, accessibilityInfo: string | null, previousAccessibilityInfo: string | null, accessibilityInfoUpdatedAt: any, canModifyAccessibility: boolean, user: { id: string | null, firstName: string, lastName: string }, salesBreakdown: { totalPayments: number } | null, priceBreakdown: { ticketsPrice: number, ticketsDiscountedPrice: number, discountsValue: number, subtotalPrice: number, miscCostsValue: number, totalPrice: number, tickets: Array<{ number: number, totalPrice: number, seatGroup: { id: string, name: string } | null, concessionType: { id: string, name: string } | null } | null> | null, miscCosts: Array<{ name: string, description: string | null, percentage: number | null, value: number | null } | null> | null } | null, performance: { id: string, start: any, end: any, doorsOpen: any, isRelaxed: boolean | null, relaxedName: string | null, durationMins: number | null, intervalDurationMins: number | null, production: { id: string, name: string, slug: string }, relaxedCategories: Array<{ id: string, shortDescription: string, longDescription: string | null } | null> | null, venue: { id: string, slug: string } | null }, tickets: Array<{ id: string, checkedInAt: any, seatGroup: { id: string, name: string }, concessionType: { id: string, name: string }, checkedInBy: { firstName: string, lastName: string } | null }>, transactions: { edges: Array<{ node: { id: string, createdAt: any, type: Types.PaymentsTransactionTypeChoices, providerName: Types.PaymentsTransactionProviderNameChoices, providerTransactionId: string | null, providerFee: number | null, value: number, cardBrand: string | null, last4: string | null } | null } | null> } | null } | null } | null> } | null };

export type AdminBookingDetailQueryVariables = Exact<{
  bookingReference: string;
}>;


export type AdminBookingDetailQuery = { bookings: { edges: Array<{ node: { createdAt: any, updatedAt: any, accessibilityInfo: string | null, previousAccessibilityInfo: string | null, accessibilityInfoUpdatedAt: any, adminDiscountPercentage: number, canModifyAccessibility: boolean, id: string, reference: string, status: Types.BookingsBookingStatusChoices, creator: { id: string | null, firstName: string, lastName: string, email: string }, user: { id: string | null, firstName: string, lastName: string, email: string }, priceBreakdown: { ticketsPrice: number, ticketsDiscountedPrice: number, discountsValue: number, subtotalPrice: number, miscCostsValue: number, totalPrice: number, tickets: Array<{ number: number, totalPrice: number, seatGroup: { id: string, name: string } | null, concessionType: { id: string, name: string } | null } | null> | null, miscCosts: Array<{ name: string, description: string | null, percentage: number | null, value: number | null } | null> | null } | null, tickets: Array<{ id: string, seatGroup: { id: string, name: string }, concessionType: { id: string, name: string } }>, performance: { id: string, start: any, end: any, doorsOpen: any, durationMins: number | null, intervalDurationMins: number | null, isRelaxed: boolean | null, relaxedName: string | null, production: { id: string, name: string, slug: string, subtitle: string | null, society: { id: string, name: string, slug: string, logo: { id: string, url: string | null } } | null, featuredImage: { id: string, url: string | null } | null }, venue: { id: string, slug: string } | null }, transactions: { edges: Array<{ node: { id: string, createdAt: any, type: Types.PaymentsTransactionTypeChoices, providerName: Types.PaymentsTransactionProviderNameChoices, providerTransactionId: string | null, providerFee: number | null, value: number, cardBrand: string | null, last4: string | null } | null } | null> } | null } | null } | null> } | null };

export type AdminPerformanceDetailQueryVariables = Exact<{
  productionSlug: string;
  performanceId: string | number;
}>;


export type AdminPerformanceDetailQuery = { production: { id: string, slug: string, name: string, permissions: Array<string | null> | null, performances: { edges: Array<{ node: { id: string, description: string | null, disabled: boolean, doorsOpen: any, start: any, end: any, durationMins: number | null, intervalDurationMins: number | null, soldOut: boolean, isOnline: boolean, isInperson: boolean, isRelaxed: boolean | null, relaxedName: string | null, isBookable: boolean, capacity: number | null, capacityRemaining: number | null, venue: { id: string, name: string, slug: string, internalCapacity: number } | null, relaxedCategories: Array<{ id: string, shortDescription: string, longDescription: string | null, helpText: string | null, defaultRelaxed: boolean, defaultSensoryFriendly: boolean } | null> | null, ticketOptions: Array<{ capacity: number, numberTicketsSold: number | null, id: string, capacityRemaining: number | null, price: number, seatGroup: { id: string, name: string, description: string | null, capacity: number | null }, concessionTypes: Array<{ price: number | null, concessionType: { id: string, name: string, description: string | null } | null } | null> | null } | null> | null, ticketsBreakdown: { totalCapacity: number, totalTicketsSold: number }, salesBreakdown: { societyRevenue: number } | null, discounts: { edges: Array<{ node: { id: string, percentage: number, performances: { edges: Array<{ node: { id: string } | null } | null> }, seatGroup: { id: string, name: string, description: string | null } | null, requirements: Array<{ id: string, number: number, concessionType: { id: string, name: string, description: string | null } }> | null } | null } | null> } } | null } | null> } } | null };

export type AdminPerformanceProductionUserPermissionsQueryVariables = Exact<{
  id: string | number;
}>;


export type AdminPerformanceProductionUserPermissionsQuery = { performance: { production: { permissions: Array<string | null> | null } } | null };

export type AdminPerformancesIndexQueryVariables = Exact<{
  productionId?: string | null | undefined;
  productionSlug?: string | null | undefined;
  offset?: number | null | undefined;
  disabled?: boolean | null | undefined;
  take?: number | null | undefined;
}>;


export type AdminPerformancesIndexQuery = { production: { id: string, performances: { pageInfo: { hasNextPage: boolean }, edges: Array<{ node: { id: string, minSeatPrice: number | null, durationMins: number | null, intervalDurationMins: number | null, doorsOpen: any, start: any, disabled: boolean, soldOut: boolean, isOnline: boolean, isBookable: boolean, isInperson: boolean, venue: { id: string, name: string } | null, ticketsBreakdown: { totalCapacity: number, totalTicketsSold: number } } | null } | null> } } | null };

export type AdminProductionCompleteBookingsQueryVariables = Exact<{
  productionSlug: string;
  performanceId?: string | number | null | undefined;
  search?: string | null | undefined;
  offset?: number | null | undefined;
  orderBy?: string | null | undefined;
  status?: Types.BookingsBookingStatusChoices | null | undefined;
  hasAccessibilityInfo?: boolean | null | undefined;
}>;


export type AdminProductionCompleteBookingsQuery = { production: { id: string, performances: { edges: Array<{ node: { id: string, bookings: { pageInfo: { startCursor: string | null, endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ node: { createdAt: any, id: string, reference: string, status: Types.BookingsBookingStatusChoices, creator: { id: string | null, firstName: string, lastName: string }, user: { id: string | null, firstName: string, lastName: string }, performance: { id: string, start: any, end: any, doorsOpen: any, production: { id: string, name: string, slug: string } }, tickets: Array<{ id: string }> } | null } | null> } } | null } | null> } } | null };

export type AdminProductionEditQueryVariables = Exact<{
  slug: string;
}>;


export type AdminProductionEditQuery = { production: { id: string, name: string, subtitle: string | null, contactEmail: string | null, slug: string, description: string | null, shortDescription: string | null, ageRating: number | null, facebookEvent: string | null, productionAlert: string | null, isBookable: boolean, society: { id: string, name: string, logo: { id: string, url: string | null } } | null, contentWarnings: Array<{ information: string | null, warning: { id: string, shortDescription: string, longDescription: string | null } }> | null, coverImage: { id: string, url: string | null } | null, featuredImage: { id: string, url: string | null } | null, posterImage: { id: string, url: string | null } | null, performances: { edges: Array<{ node: { id: string, doorsOpen: any, start: any, soldOut: boolean, isOnline: boolean, isInperson: boolean, venue: { id: string, name: string } | null } | null } | null> } } | null };

export type AdminProductionLookupQueryVariables = Exact<{
  slug: string;
}>;


export type AdminProductionLookupQuery = { production: { id: string, name: string, slug: string } | null };

export type AdminProductionPermissionsQueryVariables = Exact<{
  slug: string;
}>;


export type AdminProductionPermissionsQuery = { production: { id: string, assignablePermissions: Array<{ name: string | null, description: string | null, userCanAssign: boolean | null } | null> | null, assignedUsers: Array<{ assignedPermissions: Array<string | null> | null, user: { id: string | null, firstName: string, lastName: string, email: string } | null } | null> | null } | null };

export type AdminProductionShowQueryVariables = Exact<{
  slug: string;
}>;


export type AdminProductionShowQuery = { production: { id: string, name: string, subtitle: string | null, status: Types.ProductionsProductionStatusChoices, slug: string, start: any, end: any, isBookable: boolean, totalCapacity: number, totalTicketsSold: number, permissions: Array<string | null> | null, society: { id: string, name: string } | null, salesBreakdown: { societyRevenue: number } | null } | null };

export type AdminProductionUserPermissionsQueryVariables = Exact<{
  slug: string;
}>;


export type AdminProductionUserPermissionsQuery = { production: { permissions: Array<string | null> | null } | null };

export type AdminProductionsQueryVariables = Exact<{
  endGte?: any;
  offset?: number | null | undefined;
  status?: Types.ProductionsProductionStatusChoices | null | undefined;
  startLte?: any;
  search?: string | null | undefined;
}>;


export type AdminProductionsQuery = { productions: { pageInfo: { hasNextPage: boolean }, edges: Array<{ node: { id: string, name: string, slug: string, status: Types.ProductionsProductionStatusChoices, start: any, end: any, isBookable: boolean, featuredImage: { id: string, url: string | null } | null, society: { id: string, name: string } | null } | null } | null> } | null };

export type AdminSocietiesIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminSocietiesIndexQuery = { societies: { edges: Array<{ node: { id: string, name: string, slug: string, permissions: Array<string | null> | null, logo: { id: string, url: string | null } } | null } | null> } | null };

export type AdminVenueDetailedQueryVariables = Exact<{
  slug: string;
}>;


export type AdminVenueDetailedQuery = { venue: { id: string, name: string, slug: string, description: string | null, internalCapacity: number, address: { id: string, buildingNumber: string | null, buildingName: string | null, street: string, city: string, postcode: string, what3words: string | null, latitude: number | null, longitude: number | null }, image: { url: string | null }, seatGroups: { edges: Array<{ node: { id: string, name: string, description: string | null, capacity: number | null } | null } | null> } } | null };

export type LoadUserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadUserDetailsQuery = { me: { firstName: string, lastName: string, email: string, permissions: Array<string | null> | null } | null };

export type BoxOfficePaymentDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type BoxOfficePaymentDevicesQuery = { paymentDevices: Array<{ id: string | null, name: string | null, code: string | null, deviceId: string | null, locationId: string | null } | null> | null };

export type BoxOfficePerformanceQueryVariables = Exact<{
  id: string | number;
}>;


export type BoxOfficePerformanceQuery = { performance: { id: string, capacityRemaining: number | null, disabled: boolean, doorsOpen: any, start: any, end: any, intervalDurationMins: number | null, durationMins: number | null, soldOut: boolean, isInperson: boolean, isOnline: boolean, venue: { id: string, name: string, slug: string } | null, production: { id: string, name: string, subtitle: string | null, description: string | null, contactEmail: string | null, status: Types.ProductionsProductionStatusChoices, ageRating: number | null, slug: string, start: any, end: any, minSeatPrice: number | null, productionAlert: string | null, isBookable: boolean, posterImage: { url: string | null } | null, society: { id: string, name: string, slug: string, logo: { id: string, url: string | null } } | null, featuredImage: { id: string, url: string | null } | null, contentWarnings: Array<{ information: string | null, warning: { id: string, shortDescription: string, longDescription: string | null } }> | null } } | null };

export type BoxOfficePerformanceBookingQueryVariables = Exact<{
  performanceId: string | number;
  bookingId?: string | number | null | undefined;
  bookingReference?: string | null | undefined;
}>;


export type BoxOfficePerformanceBookingQuery = { performance: { id: string, bookings: { edges: Array<{ node: { id: string, reference: string, status: Types.BookingsBookingStatusChoices, expired: boolean, expiresAt: any, canModifyAccessibility: boolean, user: { firstName: string, lastName: string }, performance: { id: string, start: any, doorsOpen: any, production: { id: string, slug: string, name: string, posterImage: { url: string | null } | null } }, tickets: Array<{ id: string, checkedInAt: any, seatGroup: { id: string, name: string }, concessionType: { id: string, name: string }, checkedInBy: { firstName: string, lastName: string } | null }> } | null } | null> } } | null };

export type BoxOfficePerformanceBookingsQueryVariables = Exact<{
  id: string | number;
  search?: string | null | undefined;
  offset?: number | null | undefined;
  orderBy?: string | null | undefined;
  discount?: number | null | undefined;
  checkedIn?: boolean | null | undefined;
}>;


export type BoxOfficePerformanceBookingsQuery = { performance: { id: string, bookings: { pageInfo: { startCursor: string | null, endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ node: { id: string, reference: string, user: { firstName: string, lastName: string }, tickets: Array<{ checkedInAt: any }> } | null } | null> } } | null };

export type BoxOfficePerformanceTicketBreakdownQueryVariables = Exact<{
  id: string | number;
}>;


export type BoxOfficePerformanceTicketBreakdownQuery = { performance: { id: string, ticketsBreakdown: { totalCapacity: number, totalTicketsSold: number, totalTicketsCheckedIn: number, totalTicketsToCheckIn: number, totalTicketsAvailable: number } } | null };

export type BoxOfficePerformanceTicketsAvailableQueryVariables = Exact<{
  id: string | number;
}>;


export type BoxOfficePerformanceTicketsAvailableQuery = { performance: { id: string, ticketsBreakdown: { totalTicketsAvailable: number } } | null };

export type BoxOfficePerformancesQueryVariables = Exact<{
  date?: any;
}>;


export type BoxOfficePerformancesQuery = { performances: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { id: string, start: any, doorsOpen: any, production: { id: string, name: string, subtitle: string | null, description: string | null, contactEmail: string | null, status: Types.ProductionsProductionStatusChoices, ageRating: number | null, slug: string, start: any, end: any, minSeatPrice: number | null, productionAlert: string | null, isBookable: boolean, society: { id: string, name: string, slug: string, logo: { id: string, url: string | null } } | null, featuredImage: { id: string, url: string | null } | null, contentWarnings: Array<{ information: string | null, warning: { id: string, shortDescription: string, longDescription: string | null } }> | null }, venue: { id: string, name: string } | null } | null } | null> } | null };

export type PerformanceByIdQueryVariables = Exact<{
  id: string | number;
}>;


export type PerformanceByIdQuery = { performance: { id: string, doorsOpen: any, start: any, end: any, production: { id: string, name: string, subtitle: string | null, description: string | null, contactEmail: string | null, status: Types.ProductionsProductionStatusChoices, ageRating: number | null, slug: string, start: any, end: any, minSeatPrice: number | null, productionAlert: string | null, isBookable: boolean, society: { id: string, name: string, slug: string, logo: { id: string, url: string | null } } | null, featuredImage: { id: string, url: string | null } | null, contentWarnings: Array<{ information: string | null, warning: { id: string, shortDescription: string, longDescription: string | null } }> | null } } | null };

export type AllUpcomingProductionsQueryVariables = Exact<{
  now: any;
}>;


export type AllUpcomingProductionsQuery = { productions: { edges: Array<{ node: { id: string, slug: string, name: string, start: any, end: any, isBookable: boolean, society: { name: string } | null, featuredImage: { id: string, url: string | null } | null, venues: Array<{ id: string, name: string }> | null } | null } | null> } | null };

export type VenueUpcomingProductionsQueryVariables = Exact<{
  slug: string;
  now: any;
  nowDate?: any;
}>;


export type VenueUpcomingProductionsQuery = { venue: { id: string, name: string, productions: { edges: Array<{ node: { id: string, slug: string, name: string, start: any, end: any, isBookable: boolean, society: { name: string } | null, featuredImage: { id: string, url: string | null } | null, coverImage: { id: string, url: string | null } | null, venues: Array<{ id: string, name: string }> | null, performances: { edges: Array<{ node: { id: string, doorsOpen: any, start: any, soldOut: boolean, end: any, venue: { id: string, name: string } | null, production: { id: string, name: string, featuredImage: { url: string | null } | null } } | null } | null> } } | null } | null> } | null } | null };

export type CompleteBookingsQueryVariables = Exact<{
  afterCursor?: string | null | undefined;
  active?: boolean | null | undefined;
  orderBy?: string | null | undefined;
  offset?: number | null | undefined;
  max?: number | null | undefined;
}>;


export type CompleteBookingsQuery = { me: { id: string | null, bookings: { pageInfo: { hasNextPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ node: { id: string, reference: string, status: Types.BookingsBookingStatusChoices, user: { id: string | null, firstName: string, lastName: string }, performance: { id: string, start: any, end: any, doorsOpen: any, production: { id: string, name: string, slug: string } }, tickets: Array<{ id: string }> } | null } | null> } } | null };

export type MyAccountDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAccountDetailsQuery = { me: { firstName: string, lastName: string, email: string } | null };

export type UpcomingBookingsQueryVariables = Exact<{
  afterCursor?: string | null | undefined;
  active?: boolean | null | undefined;
  orderBy?: string | null | undefined;
  offset?: number | null | undefined;
  max?: number | null | undefined;
}>;


export type UpcomingBookingsQuery = { me: { id: string | null, bookings: { pageInfo: { hasNextPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ node: { id: string, reference: string, status: Types.BookingsBookingStatusChoices, user: { id: string | null, firstName: string }, performance: { id: string, start: any, doorsOpen: any, production: { id: string, name: string, slug: string, posterImage: { id: string, url: string | null } | null, featuredImage: { id: string, url: string | null } | null, society: { id: string, name: string, slug: string } | null }, venue: { id: string, name: string, slug: string, publiclyListed: boolean } | null } } | null } | null> } } | null };

export type VenuePageDetailsQueryVariables = Exact<{
  slug: string;
  now?: any;
  afterCursor?: string | null | undefined;
}>;


export type VenuePageDetailsQuery = { venue: { name: string, internalCapacity: number, description: string | null, accessibilityInfo: string | null, accessibilityShort: string | null, email: string | null, website: string | null, image: { url: string | null }, address: { id: string, buildingNumber: string | null, buildingName: string | null, street: string, city: string, postcode: string, what3words: string | null, latitude: number | null, longitude: number | null }, productions: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { id: string, name: string, slug: string, start: any, end: any, isBookable: boolean, featuredImage: { url: string | null } | null, coverImage: { url: string | null } | null, society: { name: string } | null } | null } | null> } | null } | null };

export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on AddressNode {
  id
  buildingNumber
  buildingName
  street
  city
  postcode
  what3words
  latitude
  longitude
}
    `;
export const BasicBookingDetailsFragmentDoc = gql`
    fragment BasicBookingDetails on BookingNode {
  id
  reference
  status
  user {
    id
    firstName
    lastName
  }
  performance {
    id
    start
    end
    doorsOpen
    production {
      id
      name
      slug
    }
  }
  tickets {
    id
  }
}
    `;
export const AllPriceBreakdownFragmentDoc = gql`
    fragment AllPriceBreakdown on PriceBreakdownNode {
  tickets {
    number
    seatGroup {
      id
      name
    }
    concessionType {
      id
      name
    }
    totalPrice
  }
  miscCosts {
    name
    description
    percentage
    value
  }
  ticketsPrice
  ticketsDiscountedPrice
  discountsValue
  subtotalPrice
  miscCostsValue
  totalPrice
}
    `;
export const BookingWithProductionDetailsFragmentDoc = gql`
    fragment BookingWithProductionDetails on BookingNode {
  id
  reference
  status
  accessibilityInfo
  priceBreakdown {
    ...AllPriceBreakdown
  }
  tickets {
    id
    seatGroup {
      id
      name
    }
    concessionType {
      id
      name
    }
  }
  performance {
    id
    production {
      id
      name
      slug
      subtitle
      society {
        id
        name
        slug
        logo {
          id
          url
        }
      }
      featuredImage {
        id
        url
      }
    }
    start
    end
    doorsOpen
    durationMins
    intervalDurationMins
    isRelaxed
    relaxedName
    venue {
      id
      slug
    }
  }
  transactions {
    edges {
      node {
        id
        createdAt
        type
        providerName
        providerTransactionId
        providerFee
        value
        cardBrand
        last4
      }
    }
  }
}
    ${AllPriceBreakdownFragmentDoc}`;
export const BookingTicketDetailsFragmentDoc = gql`
    fragment BookingTicketDetails on BookingNode {
  tickets {
    id
    seatGroup {
      id
      name
    }
    concessionType {
      id
      name
    }
    checkedInAt
    checkedInBy {
      firstName
      lastName
    }
  }
}
    `;
export const BookingPaymentDetailsFragmentDoc = gql`
    fragment BookingPaymentDetails on BookingNode {
  transactions {
    edges {
      node {
        id
        createdAt
        type
        providerName
        providerTransactionId
        providerFee
        value
        cardBrand
        last4
      }
    }
  }
}
    `;
export const DetailedBookingDetailsFragmentDoc = gql`
    fragment DetailedBookingDetails on BookingNode {
  id
  reference
  expired
  expiresAt
  status
  accessibilityInfo
  previousAccessibilityInfo
  accessibilityInfoUpdatedAt
  user {
    id
    firstName
    lastName
  }
  salesBreakdown {
    totalPayments
  }
  priceBreakdown {
    ...AllPriceBreakdown
  }
  ...BookingTicketDetails
  ...BookingPaymentDetails
  performance {
    id
    production {
      id
      name
      slug
    }
    start
    end
    doorsOpen
    isRelaxed
    relaxedName
    relaxedCategories {
      id
      shortDescription
      longDescription
    }
    venue {
      id
      slug
    }
    durationMins
    intervalDurationMins
  }
  canModifyAccessibility
}
    ${AllPriceBreakdownFragmentDoc}
${BookingTicketDetailsFragmentDoc}
${BookingPaymentDetailsFragmentDoc}`;
export const PerformanceTicketOptionsFragmentFragmentDoc = gql`
    fragment PerformanceTicketOptionsFragment on PerformanceSeatGroupNode {
  id
  capacityRemaining
  price
  seatGroup {
    id
    name
    description
    capacity
  }
  concessionTypes {
    concessionType {
      id
      name
      description
    }
    price
  }
}
    `;
export const ProductionBasicInfoFragmentDoc = gql`
    fragment ProductionBasicInfo on ProductionNode {
  id
  name
  subtitle
  description
  contactEmail
  society {
    id
    name
    slug
    logo {
      id
      url
    }
  }
  featuredImage {
    id
    url
  }
  status
  ageRating
  slug
  start
  end
  minSeatPrice
  contentWarnings {
    information
    warning {
      id
      shortDescription
      longDescription
    }
  }
  productionAlert
  isBookable
}
    `;
export const ProductionPerformancesFragmentDoc = gql`
    fragment ProductionPerformances on ProductionNode {
  performances {
    edges {
      node {
        id
        venue {
          id
          name
          slug
        }
        disabled
        description
        doorsOpen
        start
        end
        durationMins
        soldOut
        isInperson
        isOnline
        isRelaxed
        relaxedName
        relaxedCategories {
          id
          shortDescription
          longDescription
        }
        isBookable
      }
    }
  }
}
    `;
export const ProductionsDetailsFragmentFragmentDoc = gql`
    fragment ProductionsDetailsFragment on ProductionNodeConnection {
  edges {
    node {
      id
      slug
      name
      start
      end
      isBookable
      society {
        name
      }
      featuredImage {
        id
        url
      }
      coverImage {
        id
        url
      }
      venues {
        id
        name
      }
      performances(runOn: $nowDate) {
        edges {
          node {
            id
            doorsOpen
            start
            soldOut
            end
            venue {
              id
              name
            }
            production {
              id
              name
              featuredImage {
                url
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const AuthUserDetailsFragmentDoc = gql`
    fragment AuthUserDetails on ExtendedUserNode {
  firstName
  lastName
  email
  permissions
}
    `;
export const GenerateReportDocument = gql`
    mutation generateReport($name: String!, $start: DateTime, $end: DateTime, $options: [ReportOption]) {
  generateReport(name: $name, startTime: $start, endTime: $end, options: $options) {
    success
    downloadUri
    errors {
      ... on NonFieldError {
        message
        code
      }
      ... on FieldError {
        message
        code
        field
      }
    }
  }
}
    `;

/**
 * __useGenerateReportMutation__
 *
 * To run a mutation, you first call `useGenerateReportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateReportMutation({
 *   variables: {
 *     name: // value for 'name'
 *     start: // value for 'start'
 *     end: // value for 'end'
 *     options: // value for 'options'
 *   },
 * });
 */
export function useGenerateReportMutation(options: VueApolloComposable.UseMutationOptions<GenerateReportMutation, GenerateReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateReportMutation, GenerateReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GenerateReportMutation, GenerateReportMutationVariables>(GenerateReportDocument, options);
}
export type GenerateReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateReportMutation, GenerateReportMutationVariables>;
export const ConcessionTypeMutationDocument = gql`
    mutation concessionTypeMutation($input: ConcessionTypeMutationInput!) {
  concessionType(input: $input) {
    success
    concessionType {
      id
    }
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __useConcessionTypeMutationMutation__
 *
 * To run a mutation, you first call `useConcessionTypeMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConcessionTypeMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConcessionTypeMutationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useConcessionTypeMutationMutation(options: VueApolloComposable.UseMutationOptions<ConcessionTypeMutationMutation, ConcessionTypeMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConcessionTypeMutationMutation, ConcessionTypeMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConcessionTypeMutationMutation, ConcessionTypeMutationMutationVariables>(ConcessionTypeMutationDocument, options);
}
export type ConcessionTypeMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConcessionTypeMutationMutation, ConcessionTypeMutationMutationVariables>;
export const DeleteDiscountMutationDocument = gql`
    mutation deleteDiscountMutation($id: IdInputField!) {
  deleteDiscount(id: $id) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __useDeleteDiscountMutationMutation__
 *
 * To run a mutation, you first call `useDeleteDiscountMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscountMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDiscountMutationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDiscountMutationMutation(options: VueApolloComposable.UseMutationOptions<DeleteDiscountMutationMutation, DeleteDiscountMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteDiscountMutationMutation, DeleteDiscountMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteDiscountMutationMutation, DeleteDiscountMutationMutationVariables>(DeleteDiscountMutationDocument, options);
}
export type DeleteDiscountMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteDiscountMutationMutation, DeleteDiscountMutationMutationVariables>;
export const DeletePerformanceSeatGroupMutationDocument = gql`
    mutation deletePerformanceSeatGroupMutation($id: IdInputField!) {
  deletePerformanceSeatGroup(id: $id) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __useDeletePerformanceSeatGroupMutationMutation__
 *
 * To run a mutation, you first call `useDeletePerformanceSeatGroupMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePerformanceSeatGroupMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePerformanceSeatGroupMutationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeletePerformanceSeatGroupMutationMutation(options: VueApolloComposable.UseMutationOptions<DeletePerformanceSeatGroupMutationMutation, DeletePerformanceSeatGroupMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeletePerformanceSeatGroupMutationMutation, DeletePerformanceSeatGroupMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeletePerformanceSeatGroupMutationMutation, DeletePerformanceSeatGroupMutationMutationVariables>(DeletePerformanceSeatGroupMutationDocument, options);
}
export type DeletePerformanceSeatGroupMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeletePerformanceSeatGroupMutationMutation, DeletePerformanceSeatGroupMutationMutationVariables>;
export const DiscountMutationDocument = gql`
    mutation discountMutation($input: DiscountMutationInput!) {
  discount(input: $input) {
    success
    discount {
      id
    }
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __useDiscountMutationMutation__
 *
 * To run a mutation, you first call `useDiscountMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDiscountMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDiscountMutationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDiscountMutationMutation(options: VueApolloComposable.UseMutationOptions<DiscountMutationMutation, DiscountMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DiscountMutationMutation, DiscountMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DiscountMutationMutation, DiscountMutationMutationVariables>(DiscountMutationDocument, options);
}
export type DiscountMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DiscountMutationMutation, DiscountMutationMutationVariables>;
export const DiscountRequirementMutationDocument = gql`
    mutation discountRequirementMutation($input: DiscountRequirementMutationInput!) {
  discountRequirement(input: $input) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __useDiscountRequirementMutationMutation__
 *
 * To run a mutation, you first call `useDiscountRequirementMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDiscountRequirementMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDiscountRequirementMutationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDiscountRequirementMutationMutation(options: VueApolloComposable.UseMutationOptions<DiscountRequirementMutationMutation, DiscountRequirementMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DiscountRequirementMutationMutation, DiscountRequirementMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DiscountRequirementMutationMutation, DiscountRequirementMutationMutationVariables>(DiscountRequirementMutationDocument, options);
}
export type DiscountRequirementMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DiscountRequirementMutationMutation, DiscountRequirementMutationMutationVariables>;
export const PerformanceMutationDocument = gql`
    mutation performanceMutation($input: PerformanceMutationInput!) {
  performance(input: $input) {
    success
    performance {
      id
    }
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __usePerformanceMutationMutation__
 *
 * To run a mutation, you first call `usePerformanceMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePerformanceMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePerformanceMutationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePerformanceMutationMutation(options: VueApolloComposable.UseMutationOptions<PerformanceMutationMutation, PerformanceMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PerformanceMutationMutation, PerformanceMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PerformanceMutationMutation, PerformanceMutationMutationVariables>(PerformanceMutationDocument, options);
}
export type PerformanceMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PerformanceMutationMutation, PerformanceMutationMutationVariables>;
export const PerformanceSeatGroupDocument = gql`
    mutation performanceSeatGroup($input: PerformanceSeatGroupMutationInput!) {
  performanceSeatGroup(input: $input) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __usePerformanceSeatGroupMutation__
 *
 * To run a mutation, you first call `usePerformanceSeatGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePerformanceSeatGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePerformanceSeatGroupMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePerformanceSeatGroupMutation(options: VueApolloComposable.UseMutationOptions<PerformanceSeatGroupMutation, PerformanceSeatGroupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PerformanceSeatGroupMutation, PerformanceSeatGroupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PerformanceSeatGroupMutation, PerformanceSeatGroupMutationVariables>(PerformanceSeatGroupDocument, options);
}
export type PerformanceSeatGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PerformanceSeatGroupMutation, PerformanceSeatGroupMutationVariables>;
export const ProductionMutationDocument = gql`
    mutation productionMutation($input: ProductionMutationInput!) {
  production(input: $input) {
    success
    production {
      id
      slug
    }
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __useProductionMutationMutation__
 *
 * To run a mutation, you first call `useProductionMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProductionMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProductionMutationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useProductionMutationMutation(options: VueApolloComposable.UseMutationOptions<ProductionMutationMutation, ProductionMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProductionMutationMutation, ProductionMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProductionMutationMutation, ProductionMutationMutationVariables>(ProductionMutationDocument, options);
}
export type ProductionMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProductionMutationMutation, ProductionMutationMutationVariables>;
export const ProductionPermissionsMutationsDocument = gql`
    mutation productionPermissionsMutations($productionId: IdInputField!, $permissions: [String]!, $userEmail: String!) {
  productionPermissions(
    id: $productionId
    permissions: $permissions
    userEmail: $userEmail
  ) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __useProductionPermissionsMutationsMutation__
 *
 * To run a mutation, you first call `useProductionPermissionsMutationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProductionPermissionsMutationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProductionPermissionsMutationsMutation({
 *   variables: {
 *     productionId: // value for 'productionId'
 *     permissions: // value for 'permissions'
 *     userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useProductionPermissionsMutationsMutation(options: VueApolloComposable.UseMutationOptions<ProductionPermissionsMutationsMutation, ProductionPermissionsMutationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ProductionPermissionsMutationsMutation, ProductionPermissionsMutationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ProductionPermissionsMutationsMutation, ProductionPermissionsMutationsMutationVariables>(ProductionPermissionsMutationsDocument, options);
}
export type ProductionPermissionsMutationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ProductionPermissionsMutationsMutation, ProductionPermissionsMutationsMutationVariables>;
export const SetProductionStatusDocument = gql`
    mutation setProductionStatus($id: IdInputField!, $status: Status!, $message: String) {
  setProductionStatus(productionId: $id, status: $status, message: $message) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __useSetProductionStatusMutation__
 *
 * To run a mutation, you first call `useSetProductionStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetProductionStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetProductionStatusMutation({
 *   variables: {
 *     id: // value for 'id'
 *     status: // value for 'status'
 *     message: // value for 'message'
 *   },
 * });
 */
export function useSetProductionStatusMutation(options: VueApolloComposable.UseMutationOptions<SetProductionStatusMutation, SetProductionStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetProductionStatusMutation, SetProductionStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetProductionStatusMutation, SetProductionStatusMutationVariables>(SetProductionStatusDocument, options);
}
export type SetProductionStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetProductionStatusMutation, SetProductionStatusMutationVariables>;
export const ActiveAccountMutationDocument = gql`
    mutation activeAccountMutation($token: String!) {
  verifyAccount(token: $token) {
    success
    errors {
      ... on NonFieldError {
        message
        code
      }
      ... on FieldError {
        message
        field
        code
      }
    }
  }
}
    `;

/**
 * __useActiveAccountMutationMutation__
 *
 * To run a mutation, you first call `useActiveAccountMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActiveAccountMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActiveAccountMutationMutation({
 *   variables: {
 *     token: // value for 'token'
 *   },
 * });
 */
export function useActiveAccountMutationMutation(options: VueApolloComposable.UseMutationOptions<ActiveAccountMutationMutation, ActiveAccountMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActiveAccountMutationMutation, ActiveAccountMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ActiveAccountMutationMutation, ActiveAccountMutationMutationVariables>(ActiveAccountMutationDocument, options);
}
export type ActiveAccountMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ActiveAccountMutationMutation, ActiveAccountMutationMutationVariables>;
export const LoginMutationDocument = gql`
    mutation loginMutation($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    success
    token
    refreshToken
    user {
      verified
    }
    errors {
      ... on NonFieldError {
        message
        code
      }
      ... on FieldError {
        message
        field
        code
      }
    }
  }
}
    `;

/**
 * __useLoginMutationMutation__
 *
 * To run a mutation, you first call `useLoginMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLoginMutationMutation({
 *   variables: {
 *     email: // value for 'email'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutationMutation(options: VueApolloComposable.UseMutationOptions<LoginMutationMutation, LoginMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<LoginMutationMutation, LoginMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<LoginMutationMutation, LoginMutationMutationVariables>(LoginMutationDocument, options);
}
export type LoginMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<LoginMutationMutation, LoginMutationMutationVariables>;
export const RefreshTokenMutationDocument = gql`
    mutation refreshTokenMutation($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    token
    refreshToken
  }
}
    `;

/**
 * __useRefreshTokenMutationMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRefreshTokenMutationMutation({
 *   variables: {
 *     refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutationMutation(options: VueApolloComposable.UseMutationOptions<RefreshTokenMutationMutation, RefreshTokenMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RefreshTokenMutationMutation, RefreshTokenMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RefreshTokenMutationMutation, RefreshTokenMutationMutationVariables>(RefreshTokenMutationDocument, options);
}
export type RefreshTokenMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RefreshTokenMutationMutation, RefreshTokenMutationMutationVariables>;
export const RegisterUserMutationDocument = gql`
    mutation registerUserMutation($firstName: String!, $lastName: String!, $email: String!, $password: String!, $confirmedPassword: String!, $turnstileToken: String!) {
  register(
    firstName: $firstName
    lastName: $lastName
    email: $email
    password1: $password
    password2: $confirmedPassword
    turnstileToken: $turnstileToken
  ) {
    success
    errors {
      ... on NonFieldError {
        message
        code
      }
      ... on FieldError {
        message
        field
        code
      }
    }
  }
}
    `;

/**
 * __useRegisterUserMutationMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterUserMutationMutation({
 *   variables: {
 *     firstName: // value for 'firstName'
 *     lastName: // value for 'lastName'
 *     email: // value for 'email'
 *     password: // value for 'password'
 *     confirmedPassword: // value for 'confirmedPassword'
 *     turnstileToken: // value for 'turnstileToken'
 *   },
 * });
 */
export function useRegisterUserMutationMutation(options: VueApolloComposable.UseMutationOptions<RegisterUserMutationMutation, RegisterUserMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RegisterUserMutationMutation, RegisterUserMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RegisterUserMutationMutation, RegisterUserMutationMutationVariables>(RegisterUserMutationDocument, options);
}
export type RegisterUserMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RegisterUserMutationMutation, RegisterUserMutationMutationVariables>;
export const RequestPasswordResetMutationDocument = gql`
    mutation requestPasswordResetMutation($email: String!) {
  sendPasswordResetEmail(email: $email) {
    success
    errors {
      ... on NonFieldError {
        message
        code
      }
      ... on FieldError {
        message
        field
        code
      }
    }
  }
}
    `;

/**
 * __useRequestPasswordResetMutationMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestPasswordResetMutationMutation({
 *   variables: {
 *     email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutationMutation(options: VueApolloComposable.UseMutationOptions<RequestPasswordResetMutationMutation, RequestPasswordResetMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RequestPasswordResetMutationMutation, RequestPasswordResetMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RequestPasswordResetMutationMutation, RequestPasswordResetMutationMutationVariables>(RequestPasswordResetMutationDocument, options);
}
export type RequestPasswordResetMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RequestPasswordResetMutationMutation, RequestPasswordResetMutationMutationVariables>;
export const ResendActivationMutationDocument = gql`
    mutation resendActivationMutation($email: String!) {
  resendActivationEmail(email: $email) {
    success
    errors {
      ... on NonFieldError {
        message
        code
      }
      ... on FieldError {
        message
        field
        code
      }
    }
  }
}
    `;

/**
 * __useResendActivationMutationMutation__
 *
 * To run a mutation, you first call `useResendActivationMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResendActivationMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResendActivationMutationMutation({
 *   variables: {
 *     email: // value for 'email'
 *   },
 * });
 */
export function useResendActivationMutationMutation(options: VueApolloComposable.UseMutationOptions<ResendActivationMutationMutation, ResendActivationMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResendActivationMutationMutation, ResendActivationMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResendActivationMutationMutation, ResendActivationMutationMutationVariables>(ResendActivationMutationDocument, options);
}
export type ResendActivationMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResendActivationMutationMutation, ResendActivationMutationMutationVariables>;
export const ResetPasswordMutationDocument = gql`
    mutation resetPasswordMutation($token: String!, $password: String!, $confirmedPassword: String!) {
  passwordReset(
    token: $token
    newPassword1: $password
    newPassword2: $confirmedPassword
  ) {
    success
    errors {
      ... on NonFieldError {
        message
        code
      }
      ... on FieldError {
        message
        field
        code
      }
    }
  }
}
    `;

/**
 * __useResetPasswordMutationMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetPasswordMutationMutation({
 *   variables: {
 *     token: // value for 'token'
 *     password: // value for 'password'
 *     confirmedPassword: // value for 'confirmedPassword'
 *   },
 * });
 */
export function useResetPasswordMutationMutation(options: VueApolloComposable.UseMutationOptions<ResetPasswordMutationMutation, ResetPasswordMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResetPasswordMutationMutation, ResetPasswordMutationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResetPasswordMutationMutation, ResetPasswordMutationMutationVariables>(ResetPasswordMutationDocument, options);
}
export type ResetPasswordMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResetPasswordMutationMutation, ResetPasswordMutationMutationVariables>;
export const BookingDocument = gql`
    mutation booking($input: BookingMutationInput!) {
  booking(input: $input) {
    success
    booking {
      ...DetailedBookingDetails
    }
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    ${DetailedBookingDetailsFragmentDoc}`;

/**
 * __useBookingMutation__
 *
 * To run a mutation, you first call `useBookingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBookingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBookingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBookingMutation(options: VueApolloComposable.UseMutationOptions<BookingMutation, BookingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BookingMutation, BookingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<BookingMutation, BookingMutationVariables>(BookingDocument, options);
}
export type BookingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BookingMutation, BookingMutationVariables>;
export const CancelPaymentDocument = gql`
    mutation cancelPayment($paymentId: IdInputField!) {
  cancelPayment(paymentId: $paymentId) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __useCancelPaymentMutation__
 *
 * To run a mutation, you first call `useCancelPaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelPaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelPaymentMutation({
 *   variables: {
 *     paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useCancelPaymentMutation(options: VueApolloComposable.UseMutationOptions<CancelPaymentMutation, CancelPaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelPaymentMutation, CancelPaymentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CancelPaymentMutation, CancelPaymentMutationVariables>(CancelPaymentDocument, options);
}
export type CancelPaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelPaymentMutation, CancelPaymentMutationVariables>;
export const DeleteBookingDocument = gql`
    mutation deleteBooking($bookingId: IdInputField!) {
  deleteBooking(id: $bookingId) {
    success
    errors {
      ... on NonFieldError {
        message
      }
    }
  }
}
    `;

/**
 * __useDeleteBookingMutation__
 *
 * To run a mutation, you first call `useDeleteBookingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteBookingMutation({
 *   variables: {
 *     bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useDeleteBookingMutation(options: VueApolloComposable.UseMutationOptions<DeleteBookingMutation, DeleteBookingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteBookingMutation, DeleteBookingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteBookingMutation, DeleteBookingMutationVariables>(DeleteBookingDocument, options);
}
export type DeleteBookingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteBookingMutation, DeleteBookingMutationVariables>;
export const PayBookingDocument = gql`
    mutation payBooking($id: IdInputField!, $totalPence: Int!, $nonce: String, $provider: PaymentProvider, $idempotencyKey: String, $deviceId: String, $verifyToken: String) {
  payBooking(
    id: $id
    nonce: $nonce
    price: $totalPence
    paymentProvider: $provider
    deviceId: $deviceId
    idempotencyKey: $idempotencyKey
    verifyToken: $verifyToken
  ) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
    payment {
      id
      status
      value
      currency
      cardBrand
      last4
    }
    booking {
      ...DetailedBookingDetails
    }
  }
}
    ${DetailedBookingDetailsFragmentDoc}`;

/**
 * __usePayBookingMutation__
 *
 * To run a mutation, you first call `usePayBookingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePayBookingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePayBookingMutation({
 *   variables: {
 *     id: // value for 'id'
 *     totalPence: // value for 'totalPence'
 *     nonce: // value for 'nonce'
 *     provider: // value for 'provider'
 *     idempotencyKey: // value for 'idempotencyKey'
 *     deviceId: // value for 'deviceId'
 *     verifyToken: // value for 'verifyToken'
 *   },
 * });
 */
export function usePayBookingMutation(options: VueApolloComposable.UseMutationOptions<PayBookingMutation, PayBookingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PayBookingMutation, PayBookingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PayBookingMutation, PayBookingMutationVariables>(PayBookingDocument, options);
}
export type PayBookingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PayBookingMutation, PayBookingMutationVariables>;
export const SetBookingUserDocument = gql`
    mutation setBookingUser($id: ID!, $email: String!) {
  booking(input: {id: $id, userEmail: $email}) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __useSetBookingUserMutation__
 *
 * To run a mutation, you first call `useSetBookingUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetBookingUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetBookingUserMutation({
 *   variables: {
 *     id: // value for 'id'
 *     email: // value for 'email'
 *   },
 * });
 */
export function useSetBookingUserMutation(options: VueApolloComposable.UseMutationOptions<SetBookingUserMutation, SetBookingUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetBookingUserMutation, SetBookingUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetBookingUserMutation, SetBookingUserMutationVariables>(SetBookingUserDocument, options);
}
export type SetBookingUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetBookingUserMutation, SetBookingUserMutationVariables>;
export const UpdateBookingAccessibilityInfoDocument = gql`
    mutation updateBookingAccessibilityInfo($id: IdInputField!, $accessibilityInfo: String) {
  updateBookingAccessibilityInfo(
    bookingId: $id
    accessibilityInfo: $accessibilityInfo
  ) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __useUpdateBookingAccessibilityInfoMutation__
 *
 * To run a mutation, you first call `useUpdateBookingAccessibilityInfoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingAccessibilityInfoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBookingAccessibilityInfoMutation({
 *   variables: {
 *     id: // value for 'id'
 *     accessibilityInfo: // value for 'accessibilityInfo'
 *   },
 * });
 */
export function useUpdateBookingAccessibilityInfoMutation(options: VueApolloComposable.UseMutationOptions<UpdateBookingAccessibilityInfoMutation, UpdateBookingAccessibilityInfoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBookingAccessibilityInfoMutation, UpdateBookingAccessibilityInfoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateBookingAccessibilityInfoMutation, UpdateBookingAccessibilityInfoMutationVariables>(UpdateBookingAccessibilityInfoDocument, options);
}
export type UpdateBookingAccessibilityInfoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBookingAccessibilityInfoMutation, UpdateBookingAccessibilityInfoMutationVariables>;
export const CheckInBookingDocument = gql`
    mutation checkInBooking($reference: String!, $performanceId: IdInputField!, $tickets: [TicketIDInput]!) {
  checkInBooking(
    bookingReference: $reference
    performance: $performanceId
    tickets: $tickets
  ) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
    booking {
      ...DetailedBookingDetails
    }
  }
}
    ${DetailedBookingDetailsFragmentDoc}`;

/**
 * __useCheckInBookingMutation__
 *
 * To run a mutation, you first call `useCheckInBookingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCheckInBookingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCheckInBookingMutation({
 *   variables: {
 *     reference: // value for 'reference'
 *     performanceId: // value for 'performanceId'
 *     tickets: // value for 'tickets'
 *   },
 * });
 */
export function useCheckInBookingMutation(options: VueApolloComposable.UseMutationOptions<CheckInBookingMutation, CheckInBookingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CheckInBookingMutation, CheckInBookingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CheckInBookingMutation, CheckInBookingMutationVariables>(CheckInBookingDocument, options);
}
export type CheckInBookingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CheckInBookingMutation, CheckInBookingMutationVariables>;
export const UnCheckInBookingDocument = gql`
    mutation unCheckInBooking($reference: String!, $performanceId: IdInputField!, $tickets: [TicketIDInput]!) {
  uncheckInBooking(
    bookingReference: $reference
    performance: $performanceId
    tickets: $tickets
  ) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
    booking {
      ...DetailedBookingDetails
    }
  }
}
    ${DetailedBookingDetailsFragmentDoc}`;

/**
 * __useUnCheckInBookingMutation__
 *
 * To run a mutation, you first call `useUnCheckInBookingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnCheckInBookingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnCheckInBookingMutation({
 *   variables: {
 *     reference: // value for 'reference'
 *     performanceId: // value for 'performanceId'
 *     tickets: // value for 'tickets'
 *   },
 * });
 */
export function useUnCheckInBookingMutation(options: VueApolloComposable.UseMutationOptions<UnCheckInBookingMutation, UnCheckInBookingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnCheckInBookingMutation, UnCheckInBookingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnCheckInBookingMutation, UnCheckInBookingMutationVariables>(UnCheckInBookingDocument, options);
}
export type UnCheckInBookingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnCheckInBookingMutation, UnCheckInBookingMutationVariables>;
export const AttemptPasswordResetDocument = gql`
    mutation attemptPasswordReset($token: String!, $newPassword: String!, $confirmedNewPassword: String!) {
  passwordReset(
    token: $token
    newPassword1: $newPassword
    newPassword2: $confirmedNewPassword
  ) {
    success
    errors {
      ... on NonFieldError {
        message
      }
      ... on FieldError {
        message
        field
      }
    }
  }
}
    `;

/**
 * __useAttemptPasswordResetMutation__
 *
 * To run a mutation, you first call `useAttemptPasswordResetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAttemptPasswordResetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAttemptPasswordResetMutation({
 *   variables: {
 *     token: // value for 'token'
 *     newPassword: // value for 'newPassword'
 *     confirmedNewPassword: // value for 'confirmedNewPassword'
 *   },
 * });
 */
export function useAttemptPasswordResetMutation(options: VueApolloComposable.UseMutationOptions<AttemptPasswordResetMutation, AttemptPasswordResetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AttemptPasswordResetMutation, AttemptPasswordResetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AttemptPasswordResetMutation, AttemptPasswordResetMutationVariables>(AttemptPasswordResetDocument, options);
}
export type AttemptPasswordResetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AttemptPasswordResetMutation, AttemptPasswordResetMutationVariables>;
export const AllSiteMessagesDocument = gql`
    query allSiteMessages($afterCursor: String) {
  siteMessages(first: 9, after: $afterCursor) {
    edges {
      node {
        id
        message
        active
        indefiniteOverride
        displayStart
        eventStart
        eventEnd
        eventDuration
        creator {
          id
          firstName
          lastName
        }
        type
        dismissalPolicy
        toDisplay
      }
    }
  }
}
    `;

/**
 * __useAllSiteMessagesQuery__
 *
 * To run a query within a Vue component, call `useAllSiteMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSiteMessagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllSiteMessagesQuery({
 *   afterCursor: // value for 'afterCursor'
 * });
 */
export function useAllSiteMessagesQuery(variables: AllSiteMessagesQueryVariables | VueCompositionApi.Ref<AllSiteMessagesQueryVariables> | ReactiveFunction<AllSiteMessagesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AllSiteMessagesQuery, AllSiteMessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllSiteMessagesQuery, AllSiteMessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllSiteMessagesQuery, AllSiteMessagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllSiteMessagesQuery, AllSiteMessagesQueryVariables>(AllSiteMessagesDocument, variables, options);
}
export function useAllSiteMessagesLazyQuery(variables: AllSiteMessagesQueryVariables | VueCompositionApi.Ref<AllSiteMessagesQueryVariables> | ReactiveFunction<AllSiteMessagesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AllSiteMessagesQuery, AllSiteMessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllSiteMessagesQuery, AllSiteMessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllSiteMessagesQuery, AllSiteMessagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllSiteMessagesQuery, AllSiteMessagesQueryVariables>(AllSiteMessagesDocument, variables, options);
}
export type AllSiteMessagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllSiteMessagesQuery, AllSiteMessagesQueryVariables>;
export const AllSocietiesDocument = gql`
    query allSocieties($afterCursor: String) {
  societies(first: 9, after: $afterCursor) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        slug
        logo {
          id
          url
        }
      }
    }
  }
}
    `;

/**
 * __useAllSocietiesQuery__
 *
 * To run a query within a Vue component, call `useAllSocietiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSocietiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllSocietiesQuery({
 *   afterCursor: // value for 'afterCursor'
 * });
 */
export function useAllSocietiesQuery(variables: AllSocietiesQueryVariables | VueCompositionApi.Ref<AllSocietiesQueryVariables> | ReactiveFunction<AllSocietiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AllSocietiesQuery, AllSocietiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllSocietiesQuery, AllSocietiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllSocietiesQuery, AllSocietiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllSocietiesQuery, AllSocietiesQueryVariables>(AllSocietiesDocument, variables, options);
}
export function useAllSocietiesLazyQuery(variables: AllSocietiesQueryVariables | VueCompositionApi.Ref<AllSocietiesQueryVariables> | ReactiveFunction<AllSocietiesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AllSocietiesQuery, AllSocietiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllSocietiesQuery, AllSocietiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllSocietiesQuery, AllSocietiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllSocietiesQuery, AllSocietiesQueryVariables>(AllSocietiesDocument, variables, options);
}
export type AllSocietiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllSocietiesQuery, AllSocietiesQueryVariables>;
export const UserDraftBookingForPerformanceDocument = gql`
    query userDraftBookingForPerformance($performanceID: ID!) {
  me {
    bookings(performance: $performanceID, status: IN_PROGRESS, expired: false) {
      edges {
        node {
          ...DetailedBookingDetails
        }
      }
    }
  }
}
    ${DetailedBookingDetailsFragmentDoc}`;

/**
 * __useUserDraftBookingForPerformanceQuery__
 *
 * To run a query within a Vue component, call `useUserDraftBookingForPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDraftBookingForPerformanceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserDraftBookingForPerformanceQuery({
 *   performanceID: // value for 'performanceID'
 * });
 */
export function useUserDraftBookingForPerformanceQuery(variables: UserDraftBookingForPerformanceQueryVariables | VueCompositionApi.Ref<UserDraftBookingForPerformanceQueryVariables> | ReactiveFunction<UserDraftBookingForPerformanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserDraftBookingForPerformanceQuery, UserDraftBookingForPerformanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserDraftBookingForPerformanceQuery, UserDraftBookingForPerformanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserDraftBookingForPerformanceQuery, UserDraftBookingForPerformanceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserDraftBookingForPerformanceQuery, UserDraftBookingForPerformanceQueryVariables>(UserDraftBookingForPerformanceDocument, variables, options);
}
export function useUserDraftBookingForPerformanceLazyQuery(variables?: UserDraftBookingForPerformanceQueryVariables | VueCompositionApi.Ref<UserDraftBookingForPerformanceQueryVariables> | ReactiveFunction<UserDraftBookingForPerformanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserDraftBookingForPerformanceQuery, UserDraftBookingForPerformanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserDraftBookingForPerformanceQuery, UserDraftBookingForPerformanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserDraftBookingForPerformanceQuery, UserDraftBookingForPerformanceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserDraftBookingForPerformanceQuery, UserDraftBookingForPerformanceQueryVariables>(UserDraftBookingForPerformanceDocument, variables, options);
}
export type UserDraftBookingForPerformanceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserDraftBookingForPerformanceQuery, UserDraftBookingForPerformanceQueryVariables>;
export const FullPerformanceAndTicketOptionsDocument = gql`
    query fullPerformanceAndTicketOptions($id: ID!) {
  performance(id: $id) {
    id
    capacityRemaining
    venue {
      id
      name
      slug
    }
    disabled
    doorsOpen
    start
    end
    durationMins
    soldOut
    isInperson
    isOnline
    production {
      id
      ...ProductionBasicInfo
      ...ProductionPerformances
    }
    capacityRemaining
    discounts {
      edges {
        node {
          id
          name
          seatGroup {
            id
            name
          }
          requirements {
            number
            concessionType {
              id
              name
            }
          }
        }
      }
    }
    ticketOptions {
      ...PerformanceTicketOptionsFragment
    }
  }
}
    ${ProductionBasicInfoFragmentDoc}
${ProductionPerformancesFragmentDoc}
${PerformanceTicketOptionsFragmentFragmentDoc}`;

/**
 * __useFullPerformanceAndTicketOptionsQuery__
 *
 * To run a query within a Vue component, call `useFullPerformanceAndTicketOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullPerformanceAndTicketOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFullPerformanceAndTicketOptionsQuery({
 *   id: // value for 'id'
 * });
 */
export function useFullPerformanceAndTicketOptionsQuery(variables: FullPerformanceAndTicketOptionsQueryVariables | VueCompositionApi.Ref<FullPerformanceAndTicketOptionsQueryVariables> | ReactiveFunction<FullPerformanceAndTicketOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FullPerformanceAndTicketOptionsQuery, FullPerformanceAndTicketOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FullPerformanceAndTicketOptionsQuery, FullPerformanceAndTicketOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FullPerformanceAndTicketOptionsQuery, FullPerformanceAndTicketOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FullPerformanceAndTicketOptionsQuery, FullPerformanceAndTicketOptionsQueryVariables>(FullPerformanceAndTicketOptionsDocument, variables, options);
}
export function useFullPerformanceAndTicketOptionsLazyQuery(variables?: FullPerformanceAndTicketOptionsQueryVariables | VueCompositionApi.Ref<FullPerformanceAndTicketOptionsQueryVariables> | ReactiveFunction<FullPerformanceAndTicketOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<FullPerformanceAndTicketOptionsQuery, FullPerformanceAndTicketOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FullPerformanceAndTicketOptionsQuery, FullPerformanceAndTicketOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FullPerformanceAndTicketOptionsQuery, FullPerformanceAndTicketOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FullPerformanceAndTicketOptionsQuery, FullPerformanceAndTicketOptionsQueryVariables>(FullPerformanceAndTicketOptionsDocument, variables, options);
}
export type FullPerformanceAndTicketOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FullPerformanceAndTicketOptionsQuery, FullPerformanceAndTicketOptionsQueryVariables>;
export const HomepageUpcomingProductionsDocument = gql`
    query homepageUpcomingProductions($now: DateTime) {
  productions(orderBy: "start", end_Gte: $now, status: PUBLISHED) {
    edges {
      node {
        id
        name
        slug
        subtitle
        description
        shortDescription
        featuredImage {
          id
          url
        }
        coverImage {
          id
          url
        }
        society {
          id
          name
          slug
        }
        start
        end
      }
    }
  }
}
    `;

/**
 * __useHomepageUpcomingProductionsQuery__
 *
 * To run a query within a Vue component, call `useHomepageUpcomingProductionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomepageUpcomingProductionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHomepageUpcomingProductionsQuery({
 *   now: // value for 'now'
 * });
 */
export function useHomepageUpcomingProductionsQuery(variables: HomepageUpcomingProductionsQueryVariables | VueCompositionApi.Ref<HomepageUpcomingProductionsQueryVariables> | ReactiveFunction<HomepageUpcomingProductionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<HomepageUpcomingProductionsQuery, HomepageUpcomingProductionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HomepageUpcomingProductionsQuery, HomepageUpcomingProductionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HomepageUpcomingProductionsQuery, HomepageUpcomingProductionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HomepageUpcomingProductionsQuery, HomepageUpcomingProductionsQueryVariables>(HomepageUpcomingProductionsDocument, variables, options);
}
export function useHomepageUpcomingProductionsLazyQuery(variables: HomepageUpcomingProductionsQueryVariables | VueCompositionApi.Ref<HomepageUpcomingProductionsQueryVariables> | ReactiveFunction<HomepageUpcomingProductionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<HomepageUpcomingProductionsQuery, HomepageUpcomingProductionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HomepageUpcomingProductionsQuery, HomepageUpcomingProductionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HomepageUpcomingProductionsQuery, HomepageUpcomingProductionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<HomepageUpcomingProductionsQuery, HomepageUpcomingProductionsQueryVariables>(HomepageUpcomingProductionsDocument, variables, options);
}
export type HomepageUpcomingProductionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HomepageUpcomingProductionsQuery, HomepageUpcomingProductionsQueryVariables>;
export const MiscCostsDocument = gql`
    query miscCosts {
  miscCosts {
    edges {
      node {
        name
        description
        percentage
        value
      }
    }
  }
}
    `;

/**
 * __useMiscCostsQuery__
 *
 * To run a query within a Vue component, call `useMiscCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMiscCostsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMiscCostsQuery();
 */
export function useMiscCostsQuery(options: VueApolloComposable.UseQueryOptions<MiscCostsQuery, MiscCostsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MiscCostsQuery, MiscCostsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MiscCostsQuery, MiscCostsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MiscCostsQuery, MiscCostsQueryVariables>(MiscCostsDocument, {}, options);
}
export function useMiscCostsLazyQuery(options: VueApolloComposable.UseQueryOptions<MiscCostsQuery, MiscCostsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MiscCostsQuery, MiscCostsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MiscCostsQuery, MiscCostsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MiscCostsQuery, MiscCostsQueryVariables>(MiscCostsDocument, {}, options);
}
export type MiscCostsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MiscCostsQuery, MiscCostsQueryVariables>;
export const PerformanceTicketOptionsDocument = gql`
    query performanceTicketOptions($id: ID!) {
  performance(id: $id) {
    id
    capacityRemaining
    discounts {
      edges {
        node {
          id
          name
          seatGroup {
            id
            name
          }
          requirements {
            number
            concessionType {
              id
              name
            }
          }
        }
      }
    }
    ticketOptions {
      capacityRemaining
      seatGroup {
        id
        name
        description
      }
      concessionTypes {
        concessionType {
          id
          name
          description
        }
        price
      }
    }
  }
}
    `;

/**
 * __usePerformanceTicketOptionsQuery__
 *
 * To run a query within a Vue component, call `usePerformanceTicketOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceTicketOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePerformanceTicketOptionsQuery({
 *   id: // value for 'id'
 * });
 */
export function usePerformanceTicketOptionsQuery(variables: PerformanceTicketOptionsQueryVariables | VueCompositionApi.Ref<PerformanceTicketOptionsQueryVariables> | ReactiveFunction<PerformanceTicketOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<PerformanceTicketOptionsQuery, PerformanceTicketOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PerformanceTicketOptionsQuery, PerformanceTicketOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PerformanceTicketOptionsQuery, PerformanceTicketOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PerformanceTicketOptionsQuery, PerformanceTicketOptionsQueryVariables>(PerformanceTicketOptionsDocument, variables, options);
}
export function usePerformanceTicketOptionsLazyQuery(variables?: PerformanceTicketOptionsQueryVariables | VueCompositionApi.Ref<PerformanceTicketOptionsQueryVariables> | ReactiveFunction<PerformanceTicketOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<PerformanceTicketOptionsQuery, PerformanceTicketOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PerformanceTicketOptionsQuery, PerformanceTicketOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PerformanceTicketOptionsQuery, PerformanceTicketOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PerformanceTicketOptionsQuery, PerformanceTicketOptionsQueryVariables>(PerformanceTicketOptionsDocument, variables, options);
}
export type PerformanceTicketOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PerformanceTicketOptionsQuery, PerformanceTicketOptionsQueryVariables>;
export const ProductionBySlugDocument = gql`
    query productionBySlug($slug: String!) {
  production(slug: $slug) {
    id
    name
    status
    subtitle
    description
    contactEmail
    society {
      id
      name
      slug
      logo {
        id
        url
      }
    }
    posterImage {
      id
      url
    }
    featuredImage {
      id
      url
    }
    coverImage {
      id
      url
    }
    ageRating
    facebookEvent
    slug
    start
    end
    minSeatPrice
    contentWarnings {
      information
      warning {
        id
        shortDescription
        longDescription
      }
    }
    productionAlert
    performances(orderBy: "start", disabled: false) {
      edges {
        node {
          id
          venue {
            id
            name
            slug
            publiclyListed
          }
          doorsOpen
          isBookable
          start
          end
          soldOut
          durationMins
          intervalDurationMins
          isOnline
          isInperson
          isRelaxed
          relaxedName
          relaxedCategories {
            id
            shortDescription
            longDescription
          }
          ticketsBreakdown {
            totalCapacity
          }
        }
      }
    }
    isBookable
    crew {
      name
      role {
        department
      }
    }
    cast {
      name
      role
      profilePicture {
        url
      }
    }
    productionTeam {
      name
      role
    }
  }
}
    `;

/**
 * __useProductionBySlugQuery__
 *
 * To run a query within a Vue component, call `useProductionBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionBySlugQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProductionBySlugQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useProductionBySlugQuery(variables: ProductionBySlugQueryVariables | VueCompositionApi.Ref<ProductionBySlugQueryVariables> | ReactiveFunction<ProductionBySlugQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductionBySlugQuery, ProductionBySlugQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductionBySlugQuery, ProductionBySlugQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductionBySlugQuery, ProductionBySlugQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ProductionBySlugQuery, ProductionBySlugQueryVariables>(ProductionBySlugDocument, variables, options);
}
export function useProductionBySlugLazyQuery(variables?: ProductionBySlugQueryVariables | VueCompositionApi.Ref<ProductionBySlugQueryVariables> | ReactiveFunction<ProductionBySlugQueryVariables>, options: VueApolloComposable.UseQueryOptions<ProductionBySlugQuery, ProductionBySlugQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ProductionBySlugQuery, ProductionBySlugQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ProductionBySlugQuery, ProductionBySlugQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ProductionBySlugQuery, ProductionBySlugQueryVariables>(ProductionBySlugDocument, variables, options);
}
export type ProductionBySlugQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ProductionBySlugQuery, ProductionBySlugQueryVariables>;
export const RelaxedCategoriesDocument = gql`
    query relaxedCategories {
  relaxedCategories {
    edges {
      node {
        id
        shortDescription
        longDescription
        helpText
        defaultRelaxed
        defaultSensoryFriendly
      }
    }
  }
}
    `;

/**
 * __useRelaxedCategoriesQuery__
 *
 * To run a query within a Vue component, call `useRelaxedCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelaxedCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRelaxedCategoriesQuery();
 */
export function useRelaxedCategoriesQuery(options: VueApolloComposable.UseQueryOptions<RelaxedCategoriesQuery, RelaxedCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RelaxedCategoriesQuery, RelaxedCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RelaxedCategoriesQuery, RelaxedCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RelaxedCategoriesQuery, RelaxedCategoriesQueryVariables>(RelaxedCategoriesDocument, {}, options);
}
export function useRelaxedCategoriesLazyQuery(options: VueApolloComposable.UseQueryOptions<RelaxedCategoriesQuery, RelaxedCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RelaxedCategoriesQuery, RelaxedCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RelaxedCategoriesQuery, RelaxedCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RelaxedCategoriesQuery, RelaxedCategoriesQueryVariables>(RelaxedCategoriesDocument, {}, options);
}
export type RelaxedCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RelaxedCategoriesQuery, RelaxedCategoriesQueryVariables>;
export const SocietyDetailDocument = gql`
    query societyDetail($slug: String!) {
  society(slug: $slug) {
    name
    id
    description
    slug
    logo {
      id
      url
    }
    banner {
      id
      url
    }
    website
    contact
    productions(orderBy: "-start") {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          slug
          start
          end
          isBookable
          featuredImage {
            url
          }
          coverImage {
            url
          }
          society {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSocietyDetailQuery__
 *
 * To run a query within a Vue component, call `useSocietyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocietyDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSocietyDetailQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useSocietyDetailQuery(variables: SocietyDetailQueryVariables | VueCompositionApi.Ref<SocietyDetailQueryVariables> | ReactiveFunction<SocietyDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<SocietyDetailQuery, SocietyDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SocietyDetailQuery, SocietyDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SocietyDetailQuery, SocietyDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SocietyDetailQuery, SocietyDetailQueryVariables>(SocietyDetailDocument, variables, options);
}
export function useSocietyDetailLazyQuery(variables?: SocietyDetailQueryVariables | VueCompositionApi.Ref<SocietyDetailQueryVariables> | ReactiveFunction<SocietyDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<SocietyDetailQuery, SocietyDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SocietyDetailQuery, SocietyDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SocietyDetailQuery, SocietyDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SocietyDetailQuery, SocietyDetailQueryVariables>(SocietyDetailDocument, variables, options);
}
export type SocietyDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SocietyDetailQuery, SocietyDetailQueryVariables>;
export const UpcomingProductionsDocument = gql`
    query upcomingProductions($now: DateTime, $afterCursor: String) {
  productions(
    first: 9
    orderBy: "start"
    after: $afterCursor
    end_Gte: $now
    status: PUBLISHED
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        slug
        featuredImage {
          id
          url
        }
        start
        end
        isBookable
      }
    }
  }
}
    `;

/**
 * __useUpcomingProductionsQuery__
 *
 * To run a query within a Vue component, call `useUpcomingProductionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingProductionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUpcomingProductionsQuery({
 *   now: // value for 'now'
 *   afterCursor: // value for 'afterCursor'
 * });
 */
export function useUpcomingProductionsQuery(variables: UpcomingProductionsQueryVariables | VueCompositionApi.Ref<UpcomingProductionsQueryVariables> | ReactiveFunction<UpcomingProductionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UpcomingProductionsQuery, UpcomingProductionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UpcomingProductionsQuery, UpcomingProductionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UpcomingProductionsQuery, UpcomingProductionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UpcomingProductionsQuery, UpcomingProductionsQueryVariables>(UpcomingProductionsDocument, variables, options);
}
export function useUpcomingProductionsLazyQuery(variables: UpcomingProductionsQueryVariables | VueCompositionApi.Ref<UpcomingProductionsQueryVariables> | ReactiveFunction<UpcomingProductionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UpcomingProductionsQuery, UpcomingProductionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UpcomingProductionsQuery, UpcomingProductionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UpcomingProductionsQuery, UpcomingProductionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UpcomingProductionsQuery, UpcomingProductionsQueryVariables>(UpcomingProductionsDocument, variables, options);
}
export type UpcomingProductionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UpcomingProductionsQuery, UpcomingProductionsQueryVariables>;
export const UpcomingSiteMessagesDocument = gql`
    query upcomingSiteMessages($afterCursor: String, $displayLocation: SiteMessagesMessageDisplayLocationChoices) {
  siteMessages(
    first: 5
    orderBy: "display_start"
    after: $afterCursor
    toDisplay: true
    displayLocation: $displayLocation
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        title
        message
        active
        indefiniteOverride
        displayStart
        eventStart
        eventEnd
        eventDuration
        creator {
          id
          firstName
          lastName
        }
        type
        dismissalPolicy
        toDisplay
      }
    }
  }
}
    `;

/**
 * __useUpcomingSiteMessagesQuery__
 *
 * To run a query within a Vue component, call `useUpcomingSiteMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingSiteMessagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUpcomingSiteMessagesQuery({
 *   afterCursor: // value for 'afterCursor'
 *   displayLocation: // value for 'displayLocation'
 * });
 */
export function useUpcomingSiteMessagesQuery(variables: UpcomingSiteMessagesQueryVariables | VueCompositionApi.Ref<UpcomingSiteMessagesQueryVariables> | ReactiveFunction<UpcomingSiteMessagesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UpcomingSiteMessagesQuery, UpcomingSiteMessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UpcomingSiteMessagesQuery, UpcomingSiteMessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UpcomingSiteMessagesQuery, UpcomingSiteMessagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UpcomingSiteMessagesQuery, UpcomingSiteMessagesQueryVariables>(UpcomingSiteMessagesDocument, variables, options);
}
export function useUpcomingSiteMessagesLazyQuery(variables: UpcomingSiteMessagesQueryVariables | VueCompositionApi.Ref<UpcomingSiteMessagesQueryVariables> | ReactiveFunction<UpcomingSiteMessagesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UpcomingSiteMessagesQuery, UpcomingSiteMessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UpcomingSiteMessagesQuery, UpcomingSiteMessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UpcomingSiteMessagesQuery, UpcomingSiteMessagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UpcomingSiteMessagesQuery, UpcomingSiteMessagesQueryVariables>(UpcomingSiteMessagesDocument, variables, options);
}
export type UpcomingSiteMessagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UpcomingSiteMessagesQuery, UpcomingSiteMessagesQueryVariables>;
export const UserCompletedBookingDocument = gql`
    query userCompletedBooking($bookingRef: String!) {
  me {
    bookings(
      reference: $bookingRef
      statusIn: ["PAID", "CANCELLED", "REFUNDED", "REFUND_PROCESSING"]
    ) {
      edges {
        node {
          ...BookingWithProductionDetails
          canModifyAccessibility
        }
      }
    }
  }
}
    ${BookingWithProductionDetailsFragmentDoc}`;

/**
 * __useUserCompletedBookingQuery__
 *
 * To run a query within a Vue component, call `useUserCompletedBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCompletedBookingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserCompletedBookingQuery({
 *   bookingRef: // value for 'bookingRef'
 * });
 */
export function useUserCompletedBookingQuery(variables: UserCompletedBookingQueryVariables | VueCompositionApi.Ref<UserCompletedBookingQueryVariables> | ReactiveFunction<UserCompletedBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserCompletedBookingQuery, UserCompletedBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserCompletedBookingQuery, UserCompletedBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserCompletedBookingQuery, UserCompletedBookingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserCompletedBookingQuery, UserCompletedBookingQueryVariables>(UserCompletedBookingDocument, variables, options);
}
export function useUserCompletedBookingLazyQuery(variables?: UserCompletedBookingQueryVariables | VueCompositionApi.Ref<UserCompletedBookingQueryVariables> | ReactiveFunction<UserCompletedBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserCompletedBookingQuery, UserCompletedBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserCompletedBookingQuery, UserCompletedBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserCompletedBookingQuery, UserCompletedBookingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserCompletedBookingQuery, UserCompletedBookingQueryVariables>(UserCompletedBookingDocument, variables, options);
}
export type UserCompletedBookingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserCompletedBookingQuery, UserCompletedBookingQueryVariables>;
export const VenuesDocument = gql`
    query venues {
  venues {
    edges {
      node {
        id
        name
        internalCapacity
        image {
          url
        }
        slug
      }
    }
  }
}
    `;

/**
 * __useVenuesQuery__
 *
 * To run a query within a Vue component, call `useVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenuesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVenuesQuery();
 */
export function useVenuesQuery(options: VueApolloComposable.UseQueryOptions<VenuesQuery, VenuesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VenuesQuery, VenuesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VenuesQuery, VenuesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<VenuesQuery, VenuesQueryVariables>(VenuesDocument, {}, options);
}
export function useVenuesLazyQuery(options: VueApolloComposable.UseQueryOptions<VenuesQuery, VenuesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VenuesQuery, VenuesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VenuesQuery, VenuesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<VenuesQuery, VenuesQueryVariables>(VenuesDocument, {}, options);
}
export type VenuesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<VenuesQuery, VenuesQueryVariables>;
export const WarningsDocument = gql`
    query warnings {
  warnings {
    edges {
      node {
        id
        shortDescription
        longDescription
      }
    }
  }
}
    `;

/**
 * __useWarningsQuery__
 *
 * To run a query within a Vue component, call `useWarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarningsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWarningsQuery();
 */
export function useWarningsQuery(options: VueApolloComposable.UseQueryOptions<WarningsQuery, WarningsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WarningsQuery, WarningsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WarningsQuery, WarningsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WarningsQuery, WarningsQueryVariables>(WarningsDocument, {}, options);
}
export function useWarningsLazyQuery(options: VueApolloComposable.UseQueryOptions<WarningsQuery, WarningsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WarningsQuery, WarningsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WarningsQuery, WarningsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WarningsQuery, WarningsQueryVariables>(WarningsDocument, {}, options);
}
export type WarningsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WarningsQuery, WarningsQueryVariables>;
export const AdminBookingLookupDocument = gql`
    query adminBookingLookup($reference: String!) {
  bookings(reference: $reference) {
    edges {
      node {
        ...DetailedBookingDetails
      }
    }
  }
}
    ${DetailedBookingDetailsFragmentDoc}`;

/**
 * __useAdminBookingLookupQuery__
 *
 * To run a query within a Vue component, call `useAdminBookingLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingLookupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminBookingLookupQuery({
 *   reference: // value for 'reference'
 * });
 */
export function useAdminBookingLookupQuery(variables: AdminBookingLookupQueryVariables | VueCompositionApi.Ref<AdminBookingLookupQueryVariables> | ReactiveFunction<AdminBookingLookupQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminBookingLookupQuery, AdminBookingLookupQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminBookingLookupQuery, AdminBookingLookupQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminBookingLookupQuery, AdminBookingLookupQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminBookingLookupQuery, AdminBookingLookupQueryVariables>(AdminBookingLookupDocument, variables, options);
}
export function useAdminBookingLookupLazyQuery(variables?: AdminBookingLookupQueryVariables | VueCompositionApi.Ref<AdminBookingLookupQueryVariables> | ReactiveFunction<AdminBookingLookupQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminBookingLookupQuery, AdminBookingLookupQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminBookingLookupQuery, AdminBookingLookupQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminBookingLookupQuery, AdminBookingLookupQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminBookingLookupQuery, AdminBookingLookupQueryVariables>(AdminBookingLookupDocument, variables, options);
}
export type AdminBookingLookupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminBookingLookupQuery, AdminBookingLookupQueryVariables>;
export const AdminBookingDetailDocument = gql`
    query adminBookingDetail($bookingReference: String!) {
  bookings(reference: $bookingReference) {
    edges {
      node {
        ...BookingWithProductionDetails
        createdAt
        updatedAt
        accessibilityInfo
        previousAccessibilityInfo
        accessibilityInfoUpdatedAt
        creator {
          id
          firstName
          lastName
          email
        }
        adminDiscountPercentage
        user {
          id
          firstName
          lastName
          email
        }
        canModifyAccessibility
      }
    }
  }
}
    ${BookingWithProductionDetailsFragmentDoc}`;

/**
 * __useAdminBookingDetailQuery__
 *
 * To run a query within a Vue component, call `useAdminBookingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminBookingDetailQuery({
 *   bookingReference: // value for 'bookingReference'
 * });
 */
export function useAdminBookingDetailQuery(variables: AdminBookingDetailQueryVariables | VueCompositionApi.Ref<AdminBookingDetailQueryVariables> | ReactiveFunction<AdminBookingDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminBookingDetailQuery, AdminBookingDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminBookingDetailQuery, AdminBookingDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminBookingDetailQuery, AdminBookingDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminBookingDetailQuery, AdminBookingDetailQueryVariables>(AdminBookingDetailDocument, variables, options);
}
export function useAdminBookingDetailLazyQuery(variables?: AdminBookingDetailQueryVariables | VueCompositionApi.Ref<AdminBookingDetailQueryVariables> | ReactiveFunction<AdminBookingDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminBookingDetailQuery, AdminBookingDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminBookingDetailQuery, AdminBookingDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminBookingDetailQuery, AdminBookingDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminBookingDetailQuery, AdminBookingDetailQueryVariables>(AdminBookingDetailDocument, variables, options);
}
export type AdminBookingDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminBookingDetailQuery, AdminBookingDetailQueryVariables>;
export const AdminPerformanceDetailDocument = gql`
    query adminPerformanceDetail($productionSlug: String!, $performanceId: ID!) {
  production(slug: $productionSlug) {
    id
    slug
    name
    permissions
    performances(id: $performanceId) {
      edges {
        node {
          id
          venue {
            id
            name
            slug
            internalCapacity
          }
          description
          disabled
          doorsOpen
          start
          end
          durationMins
          intervalDurationMins
          soldOut
          isOnline
          isInperson
          isRelaxed
          relaxedName
          relaxedCategories {
            id
            shortDescription
            longDescription
            helpText
            defaultRelaxed
            defaultSensoryFriendly
          }
          isBookable
          capacity
          capacityRemaining
          ticketOptions {
            ...PerformanceTicketOptionsFragment
            capacity
            numberTicketsSold
          }
          ticketsBreakdown {
            totalCapacity
            totalTicketsSold
          }
          salesBreakdown {
            societyRevenue
          }
          discounts {
            edges {
              node {
                id
                percentage
                performances {
                  edges {
                    node {
                      id
                    }
                  }
                }
                seatGroup {
                  id
                  name
                  description
                }
                requirements {
                  id
                  number
                  concessionType {
                    id
                    name
                    description
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${PerformanceTicketOptionsFragmentFragmentDoc}`;

/**
 * __useAdminPerformanceDetailQuery__
 *
 * To run a query within a Vue component, call `useAdminPerformanceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPerformanceDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminPerformanceDetailQuery({
 *   productionSlug: // value for 'productionSlug'
 *   performanceId: // value for 'performanceId'
 * });
 */
export function useAdminPerformanceDetailQuery(variables: AdminPerformanceDetailQueryVariables | VueCompositionApi.Ref<AdminPerformanceDetailQueryVariables> | ReactiveFunction<AdminPerformanceDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminPerformanceDetailQuery, AdminPerformanceDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminPerformanceDetailQuery, AdminPerformanceDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminPerformanceDetailQuery, AdminPerformanceDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminPerformanceDetailQuery, AdminPerformanceDetailQueryVariables>(AdminPerformanceDetailDocument, variables, options);
}
export function useAdminPerformanceDetailLazyQuery(variables?: AdminPerformanceDetailQueryVariables | VueCompositionApi.Ref<AdminPerformanceDetailQueryVariables> | ReactiveFunction<AdminPerformanceDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminPerformanceDetailQuery, AdminPerformanceDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminPerformanceDetailQuery, AdminPerformanceDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminPerformanceDetailQuery, AdminPerformanceDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminPerformanceDetailQuery, AdminPerformanceDetailQueryVariables>(AdminPerformanceDetailDocument, variables, options);
}
export type AdminPerformanceDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminPerformanceDetailQuery, AdminPerformanceDetailQueryVariables>;
export const AdminPerformanceProductionUserPermissionsDocument = gql`
    query adminPerformanceProductionUserPermissions($id: ID!) {
  performance(id: $id) {
    production {
      permissions
    }
  }
}
    `;

/**
 * __useAdminPerformanceProductionUserPermissionsQuery__
 *
 * To run a query within a Vue component, call `useAdminPerformanceProductionUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPerformanceProductionUserPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminPerformanceProductionUserPermissionsQuery({
 *   id: // value for 'id'
 * });
 */
export function useAdminPerformanceProductionUserPermissionsQuery(variables: AdminPerformanceProductionUserPermissionsQueryVariables | VueCompositionApi.Ref<AdminPerformanceProductionUserPermissionsQueryVariables> | ReactiveFunction<AdminPerformanceProductionUserPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminPerformanceProductionUserPermissionsQuery, AdminPerformanceProductionUserPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminPerformanceProductionUserPermissionsQuery, AdminPerformanceProductionUserPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminPerformanceProductionUserPermissionsQuery, AdminPerformanceProductionUserPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminPerformanceProductionUserPermissionsQuery, AdminPerformanceProductionUserPermissionsQueryVariables>(AdminPerformanceProductionUserPermissionsDocument, variables, options);
}
export function useAdminPerformanceProductionUserPermissionsLazyQuery(variables?: AdminPerformanceProductionUserPermissionsQueryVariables | VueCompositionApi.Ref<AdminPerformanceProductionUserPermissionsQueryVariables> | ReactiveFunction<AdminPerformanceProductionUserPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminPerformanceProductionUserPermissionsQuery, AdminPerformanceProductionUserPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminPerformanceProductionUserPermissionsQuery, AdminPerformanceProductionUserPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminPerformanceProductionUserPermissionsQuery, AdminPerformanceProductionUserPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminPerformanceProductionUserPermissionsQuery, AdminPerformanceProductionUserPermissionsQueryVariables>(AdminPerformanceProductionUserPermissionsDocument, variables, options);
}
export type AdminPerformanceProductionUserPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminPerformanceProductionUserPermissionsQuery, AdminPerformanceProductionUserPermissionsQueryVariables>;
export const AdminPerformancesIndexDocument = gql`
    query adminPerformancesIndex($productionId: IdInputField, $productionSlug: String, $offset: Int, $disabled: Boolean, $take: Int = 10) {
  production(id: $productionId, slug: $productionSlug) {
    id
    performances(
      first: $take
      offset: $offset
      orderBy: "start"
      disabled: $disabled
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          venue {
            id
            name
          }
          minSeatPrice
          durationMins
          intervalDurationMins
          doorsOpen
          start
          disabled
          soldOut
          isOnline
          isBookable
          isInperson
          ticketsBreakdown {
            totalCapacity
            totalTicketsSold
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdminPerformancesIndexQuery__
 *
 * To run a query within a Vue component, call `useAdminPerformancesIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPerformancesIndexQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminPerformancesIndexQuery({
 *   productionId: // value for 'productionId'
 *   productionSlug: // value for 'productionSlug'
 *   offset: // value for 'offset'
 *   disabled: // value for 'disabled'
 *   take: // value for 'take'
 * });
 */
export function useAdminPerformancesIndexQuery(variables: AdminPerformancesIndexQueryVariables | VueCompositionApi.Ref<AdminPerformancesIndexQueryVariables> | ReactiveFunction<AdminPerformancesIndexQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AdminPerformancesIndexQuery, AdminPerformancesIndexQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminPerformancesIndexQuery, AdminPerformancesIndexQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminPerformancesIndexQuery, AdminPerformancesIndexQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminPerformancesIndexQuery, AdminPerformancesIndexQueryVariables>(AdminPerformancesIndexDocument, variables, options);
}
export function useAdminPerformancesIndexLazyQuery(variables: AdminPerformancesIndexQueryVariables | VueCompositionApi.Ref<AdminPerformancesIndexQueryVariables> | ReactiveFunction<AdminPerformancesIndexQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AdminPerformancesIndexQuery, AdminPerformancesIndexQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminPerformancesIndexQuery, AdminPerformancesIndexQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminPerformancesIndexQuery, AdminPerformancesIndexQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminPerformancesIndexQuery, AdminPerformancesIndexQueryVariables>(AdminPerformancesIndexDocument, variables, options);
}
export type AdminPerformancesIndexQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminPerformancesIndexQuery, AdminPerformancesIndexQueryVariables>;
export const AdminProductionCompleteBookingsDocument = gql`
    query adminProductionCompleteBookings($productionSlug: String!, $performanceId: ID, $search: String, $offset: Int, $orderBy: String, $status: BookingsBookingStatusChoices, $hasAccessibilityInfo: Boolean) {
  production(slug: $productionSlug) {
    id
    performances(id: $performanceId) {
      edges {
        node {
          id
          bookings(
            search: $search
            first: 10
            offset: $offset
            orderBy: $orderBy
            status: $status
            expired: false
            hasAccessibilityInfo: $hasAccessibilityInfo
          ) {
            pageInfo {
              startCursor
              endCursor
              hasNextPage
              hasPreviousPage
            }
            edges {
              node {
                ...BasicBookingDetails
                createdAt
                creator {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${BasicBookingDetailsFragmentDoc}`;

/**
 * __useAdminProductionCompleteBookingsQuery__
 *
 * To run a query within a Vue component, call `useAdminProductionCompleteBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductionCompleteBookingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminProductionCompleteBookingsQuery({
 *   productionSlug: // value for 'productionSlug'
 *   performanceId: // value for 'performanceId'
 *   search: // value for 'search'
 *   offset: // value for 'offset'
 *   orderBy: // value for 'orderBy'
 *   status: // value for 'status'
 *   hasAccessibilityInfo: // value for 'hasAccessibilityInfo'
 * });
 */
export function useAdminProductionCompleteBookingsQuery(variables: AdminProductionCompleteBookingsQueryVariables | VueCompositionApi.Ref<AdminProductionCompleteBookingsQueryVariables> | ReactiveFunction<AdminProductionCompleteBookingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminProductionCompleteBookingsQuery, AdminProductionCompleteBookingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionCompleteBookingsQuery, AdminProductionCompleteBookingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionCompleteBookingsQuery, AdminProductionCompleteBookingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminProductionCompleteBookingsQuery, AdminProductionCompleteBookingsQueryVariables>(AdminProductionCompleteBookingsDocument, variables, options);
}
export function useAdminProductionCompleteBookingsLazyQuery(variables?: AdminProductionCompleteBookingsQueryVariables | VueCompositionApi.Ref<AdminProductionCompleteBookingsQueryVariables> | ReactiveFunction<AdminProductionCompleteBookingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminProductionCompleteBookingsQuery, AdminProductionCompleteBookingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionCompleteBookingsQuery, AdminProductionCompleteBookingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionCompleteBookingsQuery, AdminProductionCompleteBookingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminProductionCompleteBookingsQuery, AdminProductionCompleteBookingsQueryVariables>(AdminProductionCompleteBookingsDocument, variables, options);
}
export type AdminProductionCompleteBookingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminProductionCompleteBookingsQuery, AdminProductionCompleteBookingsQueryVariables>;
export const AdminProductionEditDocument = gql`
    query adminProductionEdit($slug: String!) {
  production(slug: $slug) {
    id
    name
    subtitle
    contactEmail
    society {
      id
      name
      logo {
        id
        url
      }
    }
    slug
    description
    shortDescription
    contentWarnings {
      information
      warning {
        id
        shortDescription
        longDescription
      }
    }
    coverImage {
      id
      url
    }
    featuredImage {
      id
      url
    }
    posterImage {
      id
      url
    }
    ageRating
    facebookEvent
    productionAlert
    performances(orderBy: "start") {
      edges {
        node {
          id
          venue {
            id
            name
          }
          doorsOpen
          start
          soldOut
          isOnline
          isInperson
        }
      }
    }
    isBookable
  }
}
    `;

/**
 * __useAdminProductionEditQuery__
 *
 * To run a query within a Vue component, call `useAdminProductionEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductionEditQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminProductionEditQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useAdminProductionEditQuery(variables: AdminProductionEditQueryVariables | VueCompositionApi.Ref<AdminProductionEditQueryVariables> | ReactiveFunction<AdminProductionEditQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminProductionEditQuery, AdminProductionEditQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionEditQuery, AdminProductionEditQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionEditQuery, AdminProductionEditQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminProductionEditQuery, AdminProductionEditQueryVariables>(AdminProductionEditDocument, variables, options);
}
export function useAdminProductionEditLazyQuery(variables?: AdminProductionEditQueryVariables | VueCompositionApi.Ref<AdminProductionEditQueryVariables> | ReactiveFunction<AdminProductionEditQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminProductionEditQuery, AdminProductionEditQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionEditQuery, AdminProductionEditQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionEditQuery, AdminProductionEditQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminProductionEditQuery, AdminProductionEditQueryVariables>(AdminProductionEditDocument, variables, options);
}
export type AdminProductionEditQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminProductionEditQuery, AdminProductionEditQueryVariables>;
export const AdminProductionLookupDocument = gql`
    query adminProductionLookup($slug: String!) {
  production(slug: $slug) {
    id
    name
    slug
  }
}
    `;

/**
 * __useAdminProductionLookupQuery__
 *
 * To run a query within a Vue component, call `useAdminProductionLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductionLookupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminProductionLookupQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useAdminProductionLookupQuery(variables: AdminProductionLookupQueryVariables | VueCompositionApi.Ref<AdminProductionLookupQueryVariables> | ReactiveFunction<AdminProductionLookupQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminProductionLookupQuery, AdminProductionLookupQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionLookupQuery, AdminProductionLookupQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionLookupQuery, AdminProductionLookupQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminProductionLookupQuery, AdminProductionLookupQueryVariables>(AdminProductionLookupDocument, variables, options);
}
export function useAdminProductionLookupLazyQuery(variables?: AdminProductionLookupQueryVariables | VueCompositionApi.Ref<AdminProductionLookupQueryVariables> | ReactiveFunction<AdminProductionLookupQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminProductionLookupQuery, AdminProductionLookupQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionLookupQuery, AdminProductionLookupQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionLookupQuery, AdminProductionLookupQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminProductionLookupQuery, AdminProductionLookupQueryVariables>(AdminProductionLookupDocument, variables, options);
}
export type AdminProductionLookupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminProductionLookupQuery, AdminProductionLookupQueryVariables>;
export const AdminProductionPermissionsDocument = gql`
    query adminProductionPermissions($slug: String!) {
  production(slug: $slug) {
    id
    assignablePermissions {
      name
      description
      userCanAssign
    }
    assignedUsers {
      user {
        id
        firstName
        lastName
        email
      }
      assignedPermissions
    }
  }
}
    `;

/**
 * __useAdminProductionPermissionsQuery__
 *
 * To run a query within a Vue component, call `useAdminProductionPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductionPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminProductionPermissionsQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useAdminProductionPermissionsQuery(variables: AdminProductionPermissionsQueryVariables | VueCompositionApi.Ref<AdminProductionPermissionsQueryVariables> | ReactiveFunction<AdminProductionPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminProductionPermissionsQuery, AdminProductionPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionPermissionsQuery, AdminProductionPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionPermissionsQuery, AdminProductionPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminProductionPermissionsQuery, AdminProductionPermissionsQueryVariables>(AdminProductionPermissionsDocument, variables, options);
}
export function useAdminProductionPermissionsLazyQuery(variables?: AdminProductionPermissionsQueryVariables | VueCompositionApi.Ref<AdminProductionPermissionsQueryVariables> | ReactiveFunction<AdminProductionPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminProductionPermissionsQuery, AdminProductionPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionPermissionsQuery, AdminProductionPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionPermissionsQuery, AdminProductionPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminProductionPermissionsQuery, AdminProductionPermissionsQueryVariables>(AdminProductionPermissionsDocument, variables, options);
}
export type AdminProductionPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminProductionPermissionsQuery, AdminProductionPermissionsQueryVariables>;
export const AdminProductionShowDocument = gql`
    query adminProductionShow($slug: String!) {
  production(slug: $slug) {
    id
    name
    subtitle
    society {
      id
      name
    }
    status
    slug
    start
    end
    isBookable
    salesBreakdown {
      societyRevenue
    }
    totalCapacity
    totalTicketsSold
    permissions
  }
}
    `;

/**
 * __useAdminProductionShowQuery__
 *
 * To run a query within a Vue component, call `useAdminProductionShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductionShowQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminProductionShowQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useAdminProductionShowQuery(variables: AdminProductionShowQueryVariables | VueCompositionApi.Ref<AdminProductionShowQueryVariables> | ReactiveFunction<AdminProductionShowQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminProductionShowQuery, AdminProductionShowQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionShowQuery, AdminProductionShowQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionShowQuery, AdminProductionShowQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminProductionShowQuery, AdminProductionShowQueryVariables>(AdminProductionShowDocument, variables, options);
}
export function useAdminProductionShowLazyQuery(variables?: AdminProductionShowQueryVariables | VueCompositionApi.Ref<AdminProductionShowQueryVariables> | ReactiveFunction<AdminProductionShowQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminProductionShowQuery, AdminProductionShowQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionShowQuery, AdminProductionShowQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionShowQuery, AdminProductionShowQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminProductionShowQuery, AdminProductionShowQueryVariables>(AdminProductionShowDocument, variables, options);
}
export type AdminProductionShowQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminProductionShowQuery, AdminProductionShowQueryVariables>;
export const AdminProductionUserPermissionsDocument = gql`
    query adminProductionUserPermissions($slug: String!) {
  production(slug: $slug) {
    permissions
  }
}
    `;

/**
 * __useAdminProductionUserPermissionsQuery__
 *
 * To run a query within a Vue component, call `useAdminProductionUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductionUserPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminProductionUserPermissionsQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useAdminProductionUserPermissionsQuery(variables: AdminProductionUserPermissionsQueryVariables | VueCompositionApi.Ref<AdminProductionUserPermissionsQueryVariables> | ReactiveFunction<AdminProductionUserPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminProductionUserPermissionsQuery, AdminProductionUserPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionUserPermissionsQuery, AdminProductionUserPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionUserPermissionsQuery, AdminProductionUserPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminProductionUserPermissionsQuery, AdminProductionUserPermissionsQueryVariables>(AdminProductionUserPermissionsDocument, variables, options);
}
export function useAdminProductionUserPermissionsLazyQuery(variables?: AdminProductionUserPermissionsQueryVariables | VueCompositionApi.Ref<AdminProductionUserPermissionsQueryVariables> | ReactiveFunction<AdminProductionUserPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminProductionUserPermissionsQuery, AdminProductionUserPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionUserPermissionsQuery, AdminProductionUserPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionUserPermissionsQuery, AdminProductionUserPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminProductionUserPermissionsQuery, AdminProductionUserPermissionsQueryVariables>(AdminProductionUserPermissionsDocument, variables, options);
}
export type AdminProductionUserPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminProductionUserPermissionsQuery, AdminProductionUserPermissionsQueryVariables>;
export const AdminProductionsDocument = gql`
    query adminProductions($endGte: DateTime, $offset: Int, $status: ProductionsProductionStatusChoices, $startLte: DateTime, $search: String) {
  productions(
    first: 10
    orderBy: "-start"
    userHasPermission: "view_production"
    offset: $offset
    start_Lte: $startLte
    end_Gte: $endGte
    status: $status
    search: $search
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        id
        name
        slug
        featuredImage {
          id
          url
        }
        status
        society {
          id
          name
        }
        start
        end
        isBookable
      }
    }
  }
}
    `;

/**
 * __useAdminProductionsQuery__
 *
 * To run a query within a Vue component, call `useAdminProductionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminProductionsQuery({
 *   endGte: // value for 'endGte'
 *   offset: // value for 'offset'
 *   status: // value for 'status'
 *   startLte: // value for 'startLte'
 *   search: // value for 'search'
 * });
 */
export function useAdminProductionsQuery(variables: AdminProductionsQueryVariables | VueCompositionApi.Ref<AdminProductionsQueryVariables> | ReactiveFunction<AdminProductionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AdminProductionsQuery, AdminProductionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionsQuery, AdminProductionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionsQuery, AdminProductionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminProductionsQuery, AdminProductionsQueryVariables>(AdminProductionsDocument, variables, options);
}
export function useAdminProductionsLazyQuery(variables: AdminProductionsQueryVariables | VueCompositionApi.Ref<AdminProductionsQueryVariables> | ReactiveFunction<AdminProductionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<AdminProductionsQuery, AdminProductionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminProductionsQuery, AdminProductionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminProductionsQuery, AdminProductionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminProductionsQuery, AdminProductionsQueryVariables>(AdminProductionsDocument, variables, options);
}
export type AdminProductionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminProductionsQuery, AdminProductionsQueryVariables>;
export const AdminSocietiesIndexDocument = gql`
    query adminSocietiesIndex {
  societies(userHasPermission: "add_production") {
    edges {
      node {
        id
        name
        slug
        logo {
          id
          url
        }
        permissions
      }
    }
  }
}
    `;

/**
 * __useAdminSocietiesIndexQuery__
 *
 * To run a query within a Vue component, call `useAdminSocietiesIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSocietiesIndexQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminSocietiesIndexQuery();
 */
export function useAdminSocietiesIndexQuery(options: VueApolloComposable.UseQueryOptions<AdminSocietiesIndexQuery, AdminSocietiesIndexQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminSocietiesIndexQuery, AdminSocietiesIndexQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminSocietiesIndexQuery, AdminSocietiesIndexQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminSocietiesIndexQuery, AdminSocietiesIndexQueryVariables>(AdminSocietiesIndexDocument, {}, options);
}
export function useAdminSocietiesIndexLazyQuery(options: VueApolloComposable.UseQueryOptions<AdminSocietiesIndexQuery, AdminSocietiesIndexQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminSocietiesIndexQuery, AdminSocietiesIndexQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminSocietiesIndexQuery, AdminSocietiesIndexQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminSocietiesIndexQuery, AdminSocietiesIndexQueryVariables>(AdminSocietiesIndexDocument, {}, options);
}
export type AdminSocietiesIndexQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminSocietiesIndexQuery, AdminSocietiesIndexQueryVariables>;
export const AdminVenueDetailedDocument = gql`
    query adminVenueDetailed($slug: String!) {
  venue(slug: $slug) {
    id
    name
    slug
    description
    address {
      ...AddressFields
    }
    image {
      url
    }
    internalCapacity
    seatGroups {
      edges {
        node {
          id
          name
          description
          capacity
        }
      }
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useAdminVenueDetailedQuery__
 *
 * To run a query within a Vue component, call `useAdminVenueDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminVenueDetailedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminVenueDetailedQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useAdminVenueDetailedQuery(variables: AdminVenueDetailedQueryVariables | VueCompositionApi.Ref<AdminVenueDetailedQueryVariables> | ReactiveFunction<AdminVenueDetailedQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminVenueDetailedQuery, AdminVenueDetailedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminVenueDetailedQuery, AdminVenueDetailedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminVenueDetailedQuery, AdminVenueDetailedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminVenueDetailedQuery, AdminVenueDetailedQueryVariables>(AdminVenueDetailedDocument, variables, options);
}
export function useAdminVenueDetailedLazyQuery(variables?: AdminVenueDetailedQueryVariables | VueCompositionApi.Ref<AdminVenueDetailedQueryVariables> | ReactiveFunction<AdminVenueDetailedQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminVenueDetailedQuery, AdminVenueDetailedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminVenueDetailedQuery, AdminVenueDetailedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminVenueDetailedQuery, AdminVenueDetailedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminVenueDetailedQuery, AdminVenueDetailedQueryVariables>(AdminVenueDetailedDocument, variables, options);
}
export type AdminVenueDetailedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminVenueDetailedQuery, AdminVenueDetailedQueryVariables>;
export const LoadUserDetailsDocument = gql`
    query loadUserDetails {
  me {
    ...AuthUserDetails
  }
}
    ${AuthUserDetailsFragmentDoc}`;

/**
 * __useLoadUserDetailsQuery__
 *
 * To run a query within a Vue component, call `useLoadUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadUserDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLoadUserDetailsQuery();
 */
export function useLoadUserDetailsQuery(options: VueApolloComposable.UseQueryOptions<LoadUserDetailsQuery, LoadUserDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoadUserDetailsQuery, LoadUserDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoadUserDetailsQuery, LoadUserDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LoadUserDetailsQuery, LoadUserDetailsQueryVariables>(LoadUserDetailsDocument, {}, options);
}
export function useLoadUserDetailsLazyQuery(options: VueApolloComposable.UseQueryOptions<LoadUserDetailsQuery, LoadUserDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoadUserDetailsQuery, LoadUserDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoadUserDetailsQuery, LoadUserDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LoadUserDetailsQuery, LoadUserDetailsQueryVariables>(LoadUserDetailsDocument, {}, options);
}
export type LoadUserDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LoadUserDetailsQuery, LoadUserDetailsQueryVariables>;
export const BoxOfficePaymentDevicesDocument = gql`
    query boxOfficePaymentDevices {
  paymentDevices(paymentProvider: SQUARE_POS, paired: true) {
    id
    name
    code
    deviceId
    locationId
  }
}
    `;

/**
 * __useBoxOfficePaymentDevicesQuery__
 *
 * To run a query within a Vue component, call `useBoxOfficePaymentDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoxOfficePaymentDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBoxOfficePaymentDevicesQuery();
 */
export function useBoxOfficePaymentDevicesQuery(options: VueApolloComposable.UseQueryOptions<BoxOfficePaymentDevicesQuery, BoxOfficePaymentDevicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePaymentDevicesQuery, BoxOfficePaymentDevicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePaymentDevicesQuery, BoxOfficePaymentDevicesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BoxOfficePaymentDevicesQuery, BoxOfficePaymentDevicesQueryVariables>(BoxOfficePaymentDevicesDocument, {}, options);
}
export function useBoxOfficePaymentDevicesLazyQuery(options: VueApolloComposable.UseQueryOptions<BoxOfficePaymentDevicesQuery, BoxOfficePaymentDevicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePaymentDevicesQuery, BoxOfficePaymentDevicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePaymentDevicesQuery, BoxOfficePaymentDevicesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BoxOfficePaymentDevicesQuery, BoxOfficePaymentDevicesQueryVariables>(BoxOfficePaymentDevicesDocument, {}, options);
}
export type BoxOfficePaymentDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BoxOfficePaymentDevicesQuery, BoxOfficePaymentDevicesQueryVariables>;
export const BoxOfficePerformanceDocument = gql`
    query boxOfficePerformance($id: ID!) {
  performance(id: $id) {
    id
    capacityRemaining
    venue {
      id
      name
      slug
    }
    disabled
    doorsOpen
    start
    end
    intervalDurationMins
    durationMins
    soldOut
    isInperson
    isOnline
    production {
      ...ProductionBasicInfo
      posterImage {
        url
      }
    }
  }
}
    ${ProductionBasicInfoFragmentDoc}`;

/**
 * __useBoxOfficePerformanceQuery__
 *
 * To run a query within a Vue component, call `useBoxOfficePerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoxOfficePerformanceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBoxOfficePerformanceQuery({
 *   id: // value for 'id'
 * });
 */
export function useBoxOfficePerformanceQuery(variables: BoxOfficePerformanceQueryVariables | VueCompositionApi.Ref<BoxOfficePerformanceQueryVariables> | ReactiveFunction<BoxOfficePerformanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<BoxOfficePerformanceQuery, BoxOfficePerformanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceQuery, BoxOfficePerformanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceQuery, BoxOfficePerformanceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BoxOfficePerformanceQuery, BoxOfficePerformanceQueryVariables>(BoxOfficePerformanceDocument, variables, options);
}
export function useBoxOfficePerformanceLazyQuery(variables?: BoxOfficePerformanceQueryVariables | VueCompositionApi.Ref<BoxOfficePerformanceQueryVariables> | ReactiveFunction<BoxOfficePerformanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<BoxOfficePerformanceQuery, BoxOfficePerformanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceQuery, BoxOfficePerformanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceQuery, BoxOfficePerformanceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BoxOfficePerformanceQuery, BoxOfficePerformanceQueryVariables>(BoxOfficePerformanceDocument, variables, options);
}
export type BoxOfficePerformanceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BoxOfficePerformanceQuery, BoxOfficePerformanceQueryVariables>;
export const BoxOfficePerformanceBookingDocument = gql`
    query boxOfficePerformanceBooking($performanceId: ID!, $bookingId: ID, $bookingReference: String) {
  performance(id: $performanceId) {
    id
    bookings(id: $bookingId, reference: $bookingReference) {
      edges {
        node {
          id
          reference
          status
          user {
            firstName
            lastName
          }
          expired
          expiresAt
          canModifyAccessibility
          performance {
            id
            start
            doorsOpen
            production {
              id
              slug
              name
              posterImage {
                url
              }
            }
          }
          tickets {
            id
            seatGroup {
              id
              name
            }
            concessionType {
              id
              name
            }
            checkedInAt
            checkedInBy {
              firstName
              lastName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBoxOfficePerformanceBookingQuery__
 *
 * To run a query within a Vue component, call `useBoxOfficePerformanceBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoxOfficePerformanceBookingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBoxOfficePerformanceBookingQuery({
 *   performanceId: // value for 'performanceId'
 *   bookingId: // value for 'bookingId'
 *   bookingReference: // value for 'bookingReference'
 * });
 */
export function useBoxOfficePerformanceBookingQuery(variables: BoxOfficePerformanceBookingQueryVariables | VueCompositionApi.Ref<BoxOfficePerformanceBookingQueryVariables> | ReactiveFunction<BoxOfficePerformanceBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<BoxOfficePerformanceBookingQuery, BoxOfficePerformanceBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceBookingQuery, BoxOfficePerformanceBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceBookingQuery, BoxOfficePerformanceBookingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BoxOfficePerformanceBookingQuery, BoxOfficePerformanceBookingQueryVariables>(BoxOfficePerformanceBookingDocument, variables, options);
}
export function useBoxOfficePerformanceBookingLazyQuery(variables?: BoxOfficePerformanceBookingQueryVariables | VueCompositionApi.Ref<BoxOfficePerformanceBookingQueryVariables> | ReactiveFunction<BoxOfficePerformanceBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<BoxOfficePerformanceBookingQuery, BoxOfficePerformanceBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceBookingQuery, BoxOfficePerformanceBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceBookingQuery, BoxOfficePerformanceBookingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BoxOfficePerformanceBookingQuery, BoxOfficePerformanceBookingQueryVariables>(BoxOfficePerformanceBookingDocument, variables, options);
}
export type BoxOfficePerformanceBookingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BoxOfficePerformanceBookingQuery, BoxOfficePerformanceBookingQueryVariables>;
export const BoxOfficePerformanceBookingsDocument = gql`
    query boxOfficePerformanceBookings($id: ID!, $search: String, $offset: Int, $orderBy: String, $discount: Float, $checkedIn: Boolean) {
  performance(id: $id) {
    id
    bookings(
      search: $search
      first: 10
      offset: $offset
      orderBy: $orderBy
      status: PAID
      expired: false
      adminDiscountPercentage: $discount
      checkedIn: $checkedIn
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          user {
            firstName
            lastName
          }
          reference
          tickets {
            checkedInAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBoxOfficePerformanceBookingsQuery__
 *
 * To run a query within a Vue component, call `useBoxOfficePerformanceBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoxOfficePerformanceBookingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBoxOfficePerformanceBookingsQuery({
 *   id: // value for 'id'
 *   search: // value for 'search'
 *   offset: // value for 'offset'
 *   orderBy: // value for 'orderBy'
 *   discount: // value for 'discount'
 *   checkedIn: // value for 'checkedIn'
 * });
 */
export function useBoxOfficePerformanceBookingsQuery(variables: BoxOfficePerformanceBookingsQueryVariables | VueCompositionApi.Ref<BoxOfficePerformanceBookingsQueryVariables> | ReactiveFunction<BoxOfficePerformanceBookingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BoxOfficePerformanceBookingsQuery, BoxOfficePerformanceBookingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceBookingsQuery, BoxOfficePerformanceBookingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceBookingsQuery, BoxOfficePerformanceBookingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BoxOfficePerformanceBookingsQuery, BoxOfficePerformanceBookingsQueryVariables>(BoxOfficePerformanceBookingsDocument, variables, options);
}
export function useBoxOfficePerformanceBookingsLazyQuery(variables?: BoxOfficePerformanceBookingsQueryVariables | VueCompositionApi.Ref<BoxOfficePerformanceBookingsQueryVariables> | ReactiveFunction<BoxOfficePerformanceBookingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BoxOfficePerformanceBookingsQuery, BoxOfficePerformanceBookingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceBookingsQuery, BoxOfficePerformanceBookingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceBookingsQuery, BoxOfficePerformanceBookingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BoxOfficePerformanceBookingsQuery, BoxOfficePerformanceBookingsQueryVariables>(BoxOfficePerformanceBookingsDocument, variables, options);
}
export type BoxOfficePerformanceBookingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BoxOfficePerformanceBookingsQuery, BoxOfficePerformanceBookingsQueryVariables>;
export const BoxOfficePerformanceTicketBreakdownDocument = gql`
    query boxOfficePerformanceTicketBreakdown($id: ID!) {
  performance(id: $id) {
    id
    ticketsBreakdown {
      totalCapacity
      totalTicketsSold
      totalTicketsCheckedIn
      totalTicketsToCheckIn
      totalTicketsAvailable
    }
  }
}
    `;

/**
 * __useBoxOfficePerformanceTicketBreakdownQuery__
 *
 * To run a query within a Vue component, call `useBoxOfficePerformanceTicketBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoxOfficePerformanceTicketBreakdownQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBoxOfficePerformanceTicketBreakdownQuery({
 *   id: // value for 'id'
 * });
 */
export function useBoxOfficePerformanceTicketBreakdownQuery(variables: BoxOfficePerformanceTicketBreakdownQueryVariables | VueCompositionApi.Ref<BoxOfficePerformanceTicketBreakdownQueryVariables> | ReactiveFunction<BoxOfficePerformanceTicketBreakdownQueryVariables>, options: VueApolloComposable.UseQueryOptions<BoxOfficePerformanceTicketBreakdownQuery, BoxOfficePerformanceTicketBreakdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceTicketBreakdownQuery, BoxOfficePerformanceTicketBreakdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceTicketBreakdownQuery, BoxOfficePerformanceTicketBreakdownQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BoxOfficePerformanceTicketBreakdownQuery, BoxOfficePerformanceTicketBreakdownQueryVariables>(BoxOfficePerformanceTicketBreakdownDocument, variables, options);
}
export function useBoxOfficePerformanceTicketBreakdownLazyQuery(variables?: BoxOfficePerformanceTicketBreakdownQueryVariables | VueCompositionApi.Ref<BoxOfficePerformanceTicketBreakdownQueryVariables> | ReactiveFunction<BoxOfficePerformanceTicketBreakdownQueryVariables>, options: VueApolloComposable.UseQueryOptions<BoxOfficePerformanceTicketBreakdownQuery, BoxOfficePerformanceTicketBreakdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceTicketBreakdownQuery, BoxOfficePerformanceTicketBreakdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceTicketBreakdownQuery, BoxOfficePerformanceTicketBreakdownQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BoxOfficePerformanceTicketBreakdownQuery, BoxOfficePerformanceTicketBreakdownQueryVariables>(BoxOfficePerformanceTicketBreakdownDocument, variables, options);
}
export type BoxOfficePerformanceTicketBreakdownQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BoxOfficePerformanceTicketBreakdownQuery, BoxOfficePerformanceTicketBreakdownQueryVariables>;
export const BoxOfficePerformanceTicketsAvailableDocument = gql`
    query boxOfficePerformanceTicketsAvailable($id: ID!) {
  performance(id: $id) {
    id
    ticketsBreakdown {
      totalTicketsAvailable
    }
  }
}
    `;

/**
 * __useBoxOfficePerformanceTicketsAvailableQuery__
 *
 * To run a query within a Vue component, call `useBoxOfficePerformanceTicketsAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoxOfficePerformanceTicketsAvailableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBoxOfficePerformanceTicketsAvailableQuery({
 *   id: // value for 'id'
 * });
 */
export function useBoxOfficePerformanceTicketsAvailableQuery(variables: BoxOfficePerformanceTicketsAvailableQueryVariables | VueCompositionApi.Ref<BoxOfficePerformanceTicketsAvailableQueryVariables> | ReactiveFunction<BoxOfficePerformanceTicketsAvailableQueryVariables>, options: VueApolloComposable.UseQueryOptions<BoxOfficePerformanceTicketsAvailableQuery, BoxOfficePerformanceTicketsAvailableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceTicketsAvailableQuery, BoxOfficePerformanceTicketsAvailableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceTicketsAvailableQuery, BoxOfficePerformanceTicketsAvailableQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BoxOfficePerformanceTicketsAvailableQuery, BoxOfficePerformanceTicketsAvailableQueryVariables>(BoxOfficePerformanceTicketsAvailableDocument, variables, options);
}
export function useBoxOfficePerformanceTicketsAvailableLazyQuery(variables?: BoxOfficePerformanceTicketsAvailableQueryVariables | VueCompositionApi.Ref<BoxOfficePerformanceTicketsAvailableQueryVariables> | ReactiveFunction<BoxOfficePerformanceTicketsAvailableQueryVariables>, options: VueApolloComposable.UseQueryOptions<BoxOfficePerformanceTicketsAvailableQuery, BoxOfficePerformanceTicketsAvailableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceTicketsAvailableQuery, BoxOfficePerformanceTicketsAvailableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePerformanceTicketsAvailableQuery, BoxOfficePerformanceTicketsAvailableQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BoxOfficePerformanceTicketsAvailableQuery, BoxOfficePerformanceTicketsAvailableQueryVariables>(BoxOfficePerformanceTicketsAvailableDocument, variables, options);
}
export type BoxOfficePerformanceTicketsAvailableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BoxOfficePerformanceTicketsAvailableQuery, BoxOfficePerformanceTicketsAvailableQueryVariables>;
export const BoxOfficePerformancesDocument = gql`
    query boxOfficePerformances($date: Date) {
  performances(
    first: 9
    orderBy: "start"
    runOn: $date
    hasBoxofficePermissions: true
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        start
        doorsOpen
        production {
          ...ProductionBasicInfo
        }
        venue {
          id
          name
        }
      }
    }
  }
}
    ${ProductionBasicInfoFragmentDoc}`;

/**
 * __useBoxOfficePerformancesQuery__
 *
 * To run a query within a Vue component, call `useBoxOfficePerformancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoxOfficePerformancesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBoxOfficePerformancesQuery({
 *   date: // value for 'date'
 * });
 */
export function useBoxOfficePerformancesQuery(variables: BoxOfficePerformancesQueryVariables | VueCompositionApi.Ref<BoxOfficePerformancesQueryVariables> | ReactiveFunction<BoxOfficePerformancesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<BoxOfficePerformancesQuery, BoxOfficePerformancesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePerformancesQuery, BoxOfficePerformancesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePerformancesQuery, BoxOfficePerformancesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BoxOfficePerformancesQuery, BoxOfficePerformancesQueryVariables>(BoxOfficePerformancesDocument, variables, options);
}
export function useBoxOfficePerformancesLazyQuery(variables: BoxOfficePerformancesQueryVariables | VueCompositionApi.Ref<BoxOfficePerformancesQueryVariables> | ReactiveFunction<BoxOfficePerformancesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<BoxOfficePerformancesQuery, BoxOfficePerformancesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BoxOfficePerformancesQuery, BoxOfficePerformancesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BoxOfficePerformancesQuery, BoxOfficePerformancesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BoxOfficePerformancesQuery, BoxOfficePerformancesQueryVariables>(BoxOfficePerformancesDocument, variables, options);
}
export type BoxOfficePerformancesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BoxOfficePerformancesQuery, BoxOfficePerformancesQueryVariables>;
export const PerformanceByIdDocument = gql`
    query performanceById($id: ID!) {
  performance(id: $id) {
    id
    doorsOpen
    start
    end
    production {
      ...ProductionBasicInfo
    }
  }
}
    ${ProductionBasicInfoFragmentDoc}`;

/**
 * __usePerformanceByIdQuery__
 *
 * To run a query within a Vue component, call `usePerformanceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePerformanceByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function usePerformanceByIdQuery(variables: PerformanceByIdQueryVariables | VueCompositionApi.Ref<PerformanceByIdQueryVariables> | ReactiveFunction<PerformanceByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<PerformanceByIdQuery, PerformanceByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PerformanceByIdQuery, PerformanceByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PerformanceByIdQuery, PerformanceByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PerformanceByIdQuery, PerformanceByIdQueryVariables>(PerformanceByIdDocument, variables, options);
}
export function usePerformanceByIdLazyQuery(variables?: PerformanceByIdQueryVariables | VueCompositionApi.Ref<PerformanceByIdQueryVariables> | ReactiveFunction<PerformanceByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<PerformanceByIdQuery, PerformanceByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PerformanceByIdQuery, PerformanceByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PerformanceByIdQuery, PerformanceByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PerformanceByIdQuery, PerformanceByIdQueryVariables>(PerformanceByIdDocument, variables, options);
}
export type PerformanceByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PerformanceByIdQuery, PerformanceByIdQueryVariables>;
export const AllUpcomingProductionsDocument = gql`
    query allUpcomingProductions($now: DateTime!) {
  productions(orderBy: "start", end_Gte: $now, status: PUBLISHED) {
    edges {
      node {
        id
        slug
        name
        start
        end
        isBookable
        society {
          name
        }
        featuredImage {
          id
          url
        }
        venues {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useAllUpcomingProductionsQuery__
 *
 * To run a query within a Vue component, call `useAllUpcomingProductionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUpcomingProductionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllUpcomingProductionsQuery({
 *   now: // value for 'now'
 * });
 */
export function useAllUpcomingProductionsQuery(variables: AllUpcomingProductionsQueryVariables | VueCompositionApi.Ref<AllUpcomingProductionsQueryVariables> | ReactiveFunction<AllUpcomingProductionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllUpcomingProductionsQuery, AllUpcomingProductionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllUpcomingProductionsQuery, AllUpcomingProductionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllUpcomingProductionsQuery, AllUpcomingProductionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AllUpcomingProductionsQuery, AllUpcomingProductionsQueryVariables>(AllUpcomingProductionsDocument, variables, options);
}
export function useAllUpcomingProductionsLazyQuery(variables?: AllUpcomingProductionsQueryVariables | VueCompositionApi.Ref<AllUpcomingProductionsQueryVariables> | ReactiveFunction<AllUpcomingProductionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AllUpcomingProductionsQuery, AllUpcomingProductionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllUpcomingProductionsQuery, AllUpcomingProductionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllUpcomingProductionsQuery, AllUpcomingProductionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AllUpcomingProductionsQuery, AllUpcomingProductionsQueryVariables>(AllUpcomingProductionsDocument, variables, options);
}
export type AllUpcomingProductionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AllUpcomingProductionsQuery, AllUpcomingProductionsQueryVariables>;
export const VenueUpcomingProductionsDocument = gql`
    query venueUpcomingProductions($slug: String!, $now: DateTime!, $nowDate: Date) {
  venue(slug: $slug) {
    id
    name
    productions(orderBy: "start", end_Gte: $now, status: PUBLISHED) {
      ...ProductionsDetailsFragment
    }
  }
}
    ${ProductionsDetailsFragmentFragmentDoc}`;

/**
 * __useVenueUpcomingProductionsQuery__
 *
 * To run a query within a Vue component, call `useVenueUpcomingProductionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueUpcomingProductionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVenueUpcomingProductionsQuery({
 *   slug: // value for 'slug'
 *   now: // value for 'now'
 *   nowDate: // value for 'nowDate'
 * });
 */
export function useVenueUpcomingProductionsQuery(variables: VenueUpcomingProductionsQueryVariables | VueCompositionApi.Ref<VenueUpcomingProductionsQueryVariables> | ReactiveFunction<VenueUpcomingProductionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<VenueUpcomingProductionsQuery, VenueUpcomingProductionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VenueUpcomingProductionsQuery, VenueUpcomingProductionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VenueUpcomingProductionsQuery, VenueUpcomingProductionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<VenueUpcomingProductionsQuery, VenueUpcomingProductionsQueryVariables>(VenueUpcomingProductionsDocument, variables, options);
}
export function useVenueUpcomingProductionsLazyQuery(variables?: VenueUpcomingProductionsQueryVariables | VueCompositionApi.Ref<VenueUpcomingProductionsQueryVariables> | ReactiveFunction<VenueUpcomingProductionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<VenueUpcomingProductionsQuery, VenueUpcomingProductionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VenueUpcomingProductionsQuery, VenueUpcomingProductionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VenueUpcomingProductionsQuery, VenueUpcomingProductionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<VenueUpcomingProductionsQuery, VenueUpcomingProductionsQueryVariables>(VenueUpcomingProductionsDocument, variables, options);
}
export type VenueUpcomingProductionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<VenueUpcomingProductionsQuery, VenueUpcomingProductionsQueryVariables>;
export const CompleteBookingsDocument = gql`
    query completeBookings($afterCursor: String, $active: Boolean, $orderBy: String = "start", $offset: Int, $max: Int = 10) {
  me {
    id
    bookings(
      statusIn: ["PAID", "CANCELLED"]
      first: $max
      orderBy: $orderBy
      active: $active
      offset: $offset
      after: $afterCursor
    ) {
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...BasicBookingDetails
        }
      }
    }
  }
}
    ${BasicBookingDetailsFragmentDoc}`;

/**
 * __useCompleteBookingsQuery__
 *
 * To run a query within a Vue component, call `useCompleteBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompleteBookingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCompleteBookingsQuery({
 *   afterCursor: // value for 'afterCursor'
 *   active: // value for 'active'
 *   orderBy: // value for 'orderBy'
 *   offset: // value for 'offset'
 *   max: // value for 'max'
 * });
 */
export function useCompleteBookingsQuery(variables: CompleteBookingsQueryVariables | VueCompositionApi.Ref<CompleteBookingsQueryVariables> | ReactiveFunction<CompleteBookingsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CompleteBookingsQuery, CompleteBookingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CompleteBookingsQuery, CompleteBookingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CompleteBookingsQuery, CompleteBookingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CompleteBookingsQuery, CompleteBookingsQueryVariables>(CompleteBookingsDocument, variables, options);
}
export function useCompleteBookingsLazyQuery(variables: CompleteBookingsQueryVariables | VueCompositionApi.Ref<CompleteBookingsQueryVariables> | ReactiveFunction<CompleteBookingsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CompleteBookingsQuery, CompleteBookingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CompleteBookingsQuery, CompleteBookingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CompleteBookingsQuery, CompleteBookingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CompleteBookingsQuery, CompleteBookingsQueryVariables>(CompleteBookingsDocument, variables, options);
}
export type CompleteBookingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CompleteBookingsQuery, CompleteBookingsQueryVariables>;
export const MyAccountDetailsDocument = gql`
    query myAccountDetails {
  me {
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useMyAccountDetailsQuery__
 *
 * To run a query within a Vue component, call `useMyAccountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyAccountDetailsQuery();
 */
export function useMyAccountDetailsQuery(options: VueApolloComposable.UseQueryOptions<MyAccountDetailsQuery, MyAccountDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyAccountDetailsQuery, MyAccountDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyAccountDetailsQuery, MyAccountDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MyAccountDetailsQuery, MyAccountDetailsQueryVariables>(MyAccountDetailsDocument, {}, options);
}
export function useMyAccountDetailsLazyQuery(options: VueApolloComposable.UseQueryOptions<MyAccountDetailsQuery, MyAccountDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyAccountDetailsQuery, MyAccountDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyAccountDetailsQuery, MyAccountDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MyAccountDetailsQuery, MyAccountDetailsQueryVariables>(MyAccountDetailsDocument, {}, options);
}
export type MyAccountDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MyAccountDetailsQuery, MyAccountDetailsQueryVariables>;
export const UpcomingBookingsDocument = gql`
    query upcomingBookings($afterCursor: String, $active: Boolean = true, $orderBy: String = "start", $offset: Int, $max: Int = 4) {
  me {
    id
    bookings(
      statusIn: ["PAID"]
      first: $max
      orderBy: $orderBy
      active: $active
      offset: $offset
      after: $afterCursor
    ) {
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          reference
          status
          user {
            id
            firstName
          }
          performance {
            id
            start
            doorsOpen
            production {
              id
              name
              slug
              posterImage {
                id
                url
              }
              featuredImage {
                id
                url
              }
              society {
                id
                name
                slug
              }
            }
            venue {
              id
              name
              slug
              publiclyListed
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUpcomingBookingsQuery__
 *
 * To run a query within a Vue component, call `useUpcomingBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingBookingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUpcomingBookingsQuery({
 *   afterCursor: // value for 'afterCursor'
 *   active: // value for 'active'
 *   orderBy: // value for 'orderBy'
 *   offset: // value for 'offset'
 *   max: // value for 'max'
 * });
 */
export function useUpcomingBookingsQuery(variables: UpcomingBookingsQueryVariables | VueCompositionApi.Ref<UpcomingBookingsQueryVariables> | ReactiveFunction<UpcomingBookingsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UpcomingBookingsQuery, UpcomingBookingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UpcomingBookingsQuery, UpcomingBookingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UpcomingBookingsQuery, UpcomingBookingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UpcomingBookingsQuery, UpcomingBookingsQueryVariables>(UpcomingBookingsDocument, variables, options);
}
export function useUpcomingBookingsLazyQuery(variables: UpcomingBookingsQueryVariables | VueCompositionApi.Ref<UpcomingBookingsQueryVariables> | ReactiveFunction<UpcomingBookingsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<UpcomingBookingsQuery, UpcomingBookingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UpcomingBookingsQuery, UpcomingBookingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UpcomingBookingsQuery, UpcomingBookingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UpcomingBookingsQuery, UpcomingBookingsQueryVariables>(UpcomingBookingsDocument, variables, options);
}
export type UpcomingBookingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UpcomingBookingsQuery, UpcomingBookingsQueryVariables>;
export const VenuePageDetailsDocument = gql`
    query venuePageDetails($slug: String!, $now: DateTime, $afterCursor: String) {
  venue(slug: $slug) {
    name
    internalCapacity
    description
    accessibilityInfo
    accessibilityShort
    email
    website
    image {
      url
    }
    address {
      ...AddressFields
    }
    productions(
      first: 9
      orderBy: "start"
      after: $afterCursor
      end_Gte: $now
      status: PUBLISHED
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          slug
          start
          end
          isBookable
          featuredImage {
            url
          }
          coverImage {
            url
          }
          society {
            name
          }
        }
      }
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useVenuePageDetailsQuery__
 *
 * To run a query within a Vue component, call `useVenuePageDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenuePageDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVenuePageDetailsQuery({
 *   slug: // value for 'slug'
 *   now: // value for 'now'
 *   afterCursor: // value for 'afterCursor'
 * });
 */
export function useVenuePageDetailsQuery(variables: VenuePageDetailsQueryVariables | VueCompositionApi.Ref<VenuePageDetailsQueryVariables> | ReactiveFunction<VenuePageDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<VenuePageDetailsQuery, VenuePageDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VenuePageDetailsQuery, VenuePageDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VenuePageDetailsQuery, VenuePageDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<VenuePageDetailsQuery, VenuePageDetailsQueryVariables>(VenuePageDetailsDocument, variables, options);
}
export function useVenuePageDetailsLazyQuery(variables?: VenuePageDetailsQueryVariables | VueCompositionApi.Ref<VenuePageDetailsQueryVariables> | ReactiveFunction<VenuePageDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<VenuePageDetailsQuery, VenuePageDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VenuePageDetailsQuery, VenuePageDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<VenuePageDetailsQuery, VenuePageDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<VenuePageDetailsQuery, VenuePageDetailsQueryVariables>(VenuePageDetailsDocument, variables, options);
}
export type VenuePageDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<VenuePageDetailsQuery, VenuePageDetailsQueryVariables>;